(()=>{
if(window.MOGA_PURCHASES_LOADED)return;
window.MOGA_PURCHASES_LOADED=true;

const SUPPLIERS_KEY='moga_suppliers_v4';
const LINKS_KEY='moga_supplier_products_v4';
const ORDERS_KEY='moga_purchase_orders_v4';
const SETTINGS_KEY='moga_purchase_settings_v4';
const SEQ_KEY='moga_purchase_seq_v4';

const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
const norm=v=>String(v||'').trim().toLowerCase();
const n=v=>{const x=Number(String(v??'').replace(',','.'));return Number.isFinite(x)?x:0};
const money=v=>(n(v)).toLocaleString('lt-LT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
const cents=v=>Math.round((n(v)+Number.EPSILON)*100)/100;
const now=()=>new Date().toISOString();
const today=()=>new Date().toISOString().slice(0,10);
const id=p=>`${p}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`;
const premium=()=>!!window.MOGA_PLAN?.isPremium();

/* Bendro dokumento paskirstymas: PIRKIMAI + IŠLAIDOS */
function sharedDocExpenses(){
  try{return window.MOGA_EXPENSES?.load?.()||[]}catch(_){return[]}
}
function sharedDocAllocated(docKey,excludePurchaseId=''){
  const key=norm(docKey); if(!key)return{purchases:0,expenses:0,total:0};
  const ps=orders().filter(o=>o.id!==excludePurchaseId&&norm(o.sharedDocumentKey)===key)
    .reduce((a,o)=>a+Math.max(0,n(o.sharedAllocatedAmount ?? orderCalc(o).total)),0);
  const es=sharedDocExpenses().filter(x=>norm(x.sharedDocumentKey)===key)
    .reduce((a,x)=>a+Math.max(0,n(x.sharedAllocatedAmount ?? x.total)),0);
  return{purchases:ps,expenses:es,total:ps+es};
}
function ensurePurchaseSharedDocUi(){
  if(document.getElementById('poSharedDocBox'))return;
  const notes=document.getElementById('poNotes');
  const anchor=notes?.closest('label')||notes?.parentElement;
  if(!anchor)return;
  const box=document.createElement('div');
  box.id='poSharedDocBox'; box.className='moga-shared-doc';
  box.innerHTML=`<label class="moga-shared-doc-toggle">
    <span class="moga-shared-doc-check"><input id="poSharedDocEnabled" type="checkbox"><span>✓</span></span>
    <span><b>Dalis bendro dokumento</b><small>Naudok, kai viename PDF yra ir prekės, ir veiklos išlaidos.</small></span>
  </label>
  <div id="poSharedDocFields" class="moga-shared-doc-fields">
    <div class="moga-shared-doc-grid">
      <label><span>Dokumento ID / Nr.</span><input id="poSharedDocKey" placeholder="Pvz. ALI-001"></label>
      <label><span>Visa dokumento suma</span><input id="poSharedDocTotal" type="number" min="0" step="0.01" placeholder="0,00"></label>
      <label><span>Šiam pirkimui priskirta</span><input id="poSharedAllocated" type="number" min="0" step="0.01" placeholder="0,00"></label>
    </div>
    <div id="poSharedDocSummary" class="moga-shared-doc-summary"></div>
  </div>`;
  const fullRow=anchor.closest?.('.purchase-modal-grid,.expense-grid,.purchase-form-grid,.purchase-order-grid')||anchor.parentElement;
  if(fullRow && fullRow!==anchor && (getComputedStyle(fullRow).display==='grid'||getComputedStyle(fullRow).display==='flex')){
    fullRow.appendChild(box);
  }else anchor.insertAdjacentElement('afterend',box);
  ['poSharedDocEnabled','poSharedDocKey','poSharedDocTotal','poSharedAllocated'].forEach(id=>{
    document.getElementById(id)?.addEventListener('input',refreshPurchaseSharedDocUi);
    document.getElementById(id)?.addEventListener('change',refreshPurchaseSharedDocUi);
  });
}
function refreshPurchaseSharedDocUi(){
  const enabled=!!document.getElementById('poSharedDocEnabled')?.checked;
  const fields=document.getElementById('poSharedDocFields'); if(fields){fields.classList.toggle('open',enabled);}
  if(!enabled)return;
  const key=document.getElementById('poSharedDocKey')?.value||'';
  const full=Math.max(0,n(document.getElementById('poSharedDocTotal')?.value));
  const mine=Math.max(0,n(document.getElementById('poSharedAllocated')?.value));
  const x=sharedDocAllocated(key,editingOrderId||'');
  const used=x.total+mine, left=full-used;
  const s=document.getElementById('poSharedDocSummary'); if(!s)return;
  s.textContent=`Pirkimai: ${money(x.purchases+mine)} · Išlaidos: ${money(x.expenses)} · Paskirstyta: ${money(used)} / ${money(full)} · ${left>=-0.005?'Liko '+money(Math.max(0,left)):'VIRŠYTA '+money(Math.abs(left))}`;
  s.style.color=left < -0.005 ? '#b00000' : (Math.abs(left)<0.005&&full>0 ? '#137333' : '#7a5a00');
}


function load(key,fallback){
  try{const x=JSON.parse(localStorage.getItem(key)||'null');return x??fallback}catch(e){return fallback}
}
function save(key,val){localStorage.setItem(key,JSON.stringify(val));return val}
function suppliers(){const x=load(SUPPLIERS_KEY,[]);return Array.isArray(x)?x:[]}
function setSuppliers(x){return save(SUPPLIERS_KEY,x||[])}
function links(){const x=load(LINKS_KEY,[]);return Array.isArray(x)?x:[]}
function setLinks(x){
  const val=save(LINKS_KEY,x||[]);
  try{window.dispatchEvent(new CustomEvent('moga:supplier-links-change',{detail:{count:Array.isArray(val)?val.length:0}}));}catch(_){}
  return val;
}
function orders(){const x=load(ORDERS_KEY,[]);return Array.isArray(x)?x:[]}
function setOrders(x){return save(ORDERS_KEY,x||[])}
function settings(){return{currency:'EUR',targetMultiplier:2,defaultVatRate:21,autoOrderStatus:'ordered',...load(SETTINGS_KEY,{}),costMethod:'fifo'}}
function setSettings(x){return save(SETTINGS_KEY,{...settings(),...x})}
function products(){return window.MOGA_INVENTORY?.products?.()||([])}
function product(id){return window.MOGA_INVENTORY?.findProductById?.(id)||products().find(p=>p.inventoryId===id)}
function invRecord(id){return window.MOGA_INVENTORY?.getRecord?.(id)||{qty:0,reserved:0,min:0}}
function available(id){return window.MOGA_INVENTORY?.available?.(id)||0}
function supplier(id){return suppliers().find(x=>x.id===id)}
function supplierNameForOrder(o){
  return supplier(o?.supplierId)?.name||o?.supplierSnapshot?.name||o?.supplierName||'Tiekėjas pašalintas';
}
function supplierContactForOrder(o){
  const s=supplier(o?.supplierId),snap=o?.supplierSnapshot||{};
  return s?.contactName||s?.email||snap.contactName||snap.email||'';
}
function linkById(id){return links().find(x=>x.id===id)}
function supplierLinkEffectiveCost(l){
  const p=products().find(x=>String(x.inventoryId||'')===String(l?.productId||''));
  const linked=Math.max(0,n(l?.unitCost));
  return linked>0?linked:Math.max(0,n(p?.cost));
}
function orderById(id){return orders().find(x=>x.id===id)}

function nextPoNo(){
  const seq=Math.max(1,parseInt(localStorage.getItem(SEQ_KEY)||'1',10)||1);
  localStorage.setItem(SEQ_KEY,String(seq+1));
  return`PO-${new Date().getFullYear()}-${String(seq).padStart(4,'0')}`;
}
function lineBase(line){return n(line.qty)*n(line.unitCost)*(1-n(line.discount)/100)}
function orderCalc(o){
  // Pirkimų apskaita rodoma / apmokama centais, todėl galutinius piniginius dydžius
  // suapvaliname iki 2 skaitmenų. Tai neleidžia 72,696 tipo kiekiams sukaupti
  // paslėptų 0,001–0,004 € likučių ir KPI rodyti fiktyvią 0,01 € skolą.
  const subtotalRaw=(o.lines||[]).reduce((a,l)=>a+lineBase(l),0);
  const orderDiscountRaw=Math.max(0,n(o.discount));
  const afterDiscountRaw=Math.max(0,subtotalRaw-orderDiscountRaw);
  const shippingRaw=Math.max(0,n(o.shipping)),otherRaw=Math.max(0,n(o.otherCosts));
  const netRaw=afterDiscountRaw+shippingRaw+otherRaw;
  const vatRate=Math.max(0,n(o.vatRate));
  const vatRaw=o.pricesIncludeVat?netRaw-(netRaw/(1+vatRate/100)):netRaw*vatRate/100;
  const total=cents(o.pricesIncludeVat?netRaw:netRaw+vatRaw);
  const paid=cents(Math.max(0,n(o.paidAmount)));
  const diff=total-paid;
  const outstanding=Math.abs(diff)<0.005?0:cents(Math.max(0,diff));

  return{
    subtotal:cents(subtotalRaw),
    orderDiscount:cents(orderDiscountRaw),
    afterDiscount:cents(afterDiscountRaw),
    shipping:cents(shippingRaw),
    other:cents(otherRaw),
    net:cents(netRaw),
    vat:cents(vatRaw),
    total,
    paid,
    outstanding
  };
}
function effectiveLineCost(o,line){
  const baseTotal=(o.lines||[]).reduce((a,l)=>a+lineBase(l),0);
  const lineTotal=lineBase(line);
  const extras=Math.max(0,n(o.shipping))+Math.max(0,n(o.otherCosts))-Math.max(0,n(o.discount));
  const alloc=baseTotal>0?extras*(lineTotal/baseTotal):0;
  const q=Math.max(1,n(line.qty));
  return Math.max(0,(lineTotal+alloc)/q);
}
function receivedTotal(line){return Math.max(0,n(line.receivedQty))}
function remaining(line){return Math.max(0,n(line.qty)-receivedTotal(line))}
function incomingForProduct(productId){
  return orders().filter(o=>!['draft','received','cancelled'].includes(o.status)).reduce((sum,o)=>{
    return sum+(o.lines||[]).filter(l=>l.productId===productId).reduce((a,l)=>a+remaining(l),0);
  },0);
}
function orderStatusAuto(o){
  if(o.status==='cancelled')return'cancelled';
  const lines=o.lines||[];
  if(!lines.length)return o.status||'draft';
  const ordered=lines.reduce((a,l)=>a+n(l.qty),0);
  const got=lines.reduce((a,l)=>a+n(l.receivedQty),0);
  if(got>=ordered&&ordered>0)return'received';
  if(got>0)return'partial';
  return o.status||'draft';
}
function paymentStatus(o){
  const c=orderCalc(o);
  if(c.total<=0||c.paid>=c.total-.005)return'paid';
  if(c.paid>0)return'partial';
  return'unpaid';
}
function statusLabel(x){return({draft:'JUODRAŠTIS',ordered:'UŽSAKYTA',confirmed:'PATVIRTINTA',shipped:'IŠSIŲSTA',partial:'DALINAI GAUTA',received:'GAUTA',cancelled:'ATŠAUKTA'})[x]||x}
function payLabel(x){return({paid:'APMOKĖTA',partial:'DALINAI',unpaid:'NEAPMOKĖTA'})[x]||x}

function supplierSpend(sid){
  return orders().filter(o=>o.supplierId===sid&&o.status!=='cancelled').reduce((a,o)=>a+orderCalc(o).total,0)
}
function supplierOpen(sid){
  return orders().filter(o=>o.supplierId===sid&&!['received','cancelled'].includes(o.status)).length
}
function supplierLinksCount(sid){return links().filter(x=>x.supplierId===sid).length}

function activePurchasePane(){
  return document.querySelector('#purchaseSheet .purchase-pane.active')?.dataset?.purchasePane||'orders';
}
function renderActivePurchasePane(){
  const name=activePurchasePane();
  if(name==='orders')return renderOrders();
  if(name==='suppliers')return renderSuppliers();
  if(name==='links')return renderLinks();
  if(name==='reorder')return renderReorder();
  if(name==='analytics')return renderAnalytics();
  return renderOrders();
}
function setPage(page){
  if(page!=='purchases')return false;
  if(!premium()){alert('PIRKIMAI prieinami MOGA SF PREMIUM plane.');return true}
  ['invoiceSheet','trackingSheet','statsSheet','warehouseSheet'].forEach(id=>{
    const el=document.getElementById(id);if(!el)return;
    if(id==='invoiceSheet')el.style.display='none';else el.classList.remove('active');
  });
  document.getElementById('purchaseSheet')?.classList.add('active');
  ['tabInvoice','tabTracking','tabStats','tabWarehouse'].forEach(id=>document.getElementById(id)?.classList.remove('active'));
  document.getElementById('tabPurchases')?.classList.add('active');
  /* Greitas atidarymas: renderiname tik matomą PIRKIMAI skiltį.
     Kitos skiltys persiskaičiuoja tik jas atidarius. */
  renderActivePurchasePane();
  return true;
}
const baseSwitch=window.switchPage;
window.switchPage=function(page){
  document.getElementById('purchaseSheet')?.classList.remove('active');
  document.getElementById('tabPurchases')?.classList.remove('active');
  if(setPage(page))return;
  return baseSwitch(page);
};

function switchPane(name){
  document.querySelectorAll('#purchaseSheet .purchase-pane').forEach(x=>x.classList.toggle('active',x.dataset.purchasePane===name));
  document.querySelectorAll('#purchaseSheet .purchase-tabs button').forEach(x=>x.classList.toggle('active',x.dataset.purchaseTab===name));
  if(name==='orders')renderOrders();
  if(name==='suppliers')renderSuppliers();
  if(name==='links')renderLinks();
  if(name==='reorder')renderReorder();
  if(name==='analytics')renderAnalytics();
}
window.switchPurchasePane=switchPane;

function renderKpis(){
  const os=orders(),sup=suppliers();
  const active=os.filter(o=>!['received','cancelled'].includes(o.status));
  const incoming=active.filter(o=>o.status!=='draft').reduce((a,o)=>a+(o.lines||[]).reduce((b,l)=>b+remaining(l),0),0);
  const outstanding=os.filter(o=>o.status!=='cancelled').reduce((a,o)=>a+orderCalc(o).outstanding,0);
  const month=today().slice(0,7);
  const monthSpend=os.filter(o=>String(o.date||'').slice(0,7)===month&&o.status!=='cancelled').reduce((a,o)=>a+orderCalc(o).total,0);
  const linked=new Set(links().map(x=>x.productId)).size;
  const put=(id,v)=>{const e=document.getElementById(id);if(e)e.textContent=v};
  put('purchaseKpiSuppliers',sup.filter(x=>x.active!==false).length);
  put('purchaseKpiOpen',active.length);
  put('purchaseKpiIncoming',incoming.toLocaleString('lt-LT'));
  put('purchaseKpiMonth',money(monthSpend));
  put('purchaseKpiOutstanding',money(outstanding));
  put('purchaseKpiLinked',`${linked}/${products().length}`);
}
function renderOrders(){
  renderKpis();
  const purchaseOrderSearchEl=document.getElementById('purchaseOrderSearch');if(purchaseOrderSearchEl&&!purchaseOrderSearchEl.placeholder)purchaseOrderSearchEl.placeholder='Paieška';
  const q=norm(document.getElementById('purchaseOrderSearch')?.value);
  const st=document.getElementById('purchaseOrderStatus')?.value||'all';
  const sid=document.getElementById('purchaseOrderSupplier')?.value||'all';
  /* Vienas localStorage nuskaitymas visam renderiui vietoje supplier() šimtus kartų. */
  const sup=suppliers();
  const supplierMap=new Map(sup.map(x=>[String(x.id),x]));
  const supplierFast=id=>supplierMap.get(String(id||''))||null;
  const supplierNameFast=o=>supplierFast(o?.supplierId)?.name||o?.supplierSnapshot?.name||o?.supplierName||'Tiekėjas pašalintas';
  const supplierContactFast=o=>{const x=supplierFast(o?.supplierId),snap=o?.supplierSnapshot||{};return x?.contactName||x?.email||snap.contactName||snap.email||''};
  const sel=document.getElementById('purchaseOrderSupplier');
  if(sel){
    const cur=sel.value||'all';
    sel.innerHTML='<option value="all">Visi tiekėjai</option>'+sup.map(x=>`<option value="${x.id}">${esc(x.name)}</option>`).join('');
    sel.value=sup.some(x=>x.id===cur)?cur:'all';
  }
  let arr=orders().slice().sort((a,b)=>String(b.createdAt||'').localeCompare(String(a.createdAt||''))).filter(o=>{
    const hay=norm([o.no,supplierNameFast(o),o.reference,o.documentName,o.accountingGroup,o.tracking,o.notes].join(' '));
    if(q&&!hay.includes(q))return false;
    if(st!=='all'&&o.status!==st)return false;
    if(sid!=='all'&&o.supplierId!==sid)return false;
    return true;
  });
  const tb=document.getElementById('purchaseOrderBody');if(!tb)return;
  if(!arr.length){tb.innerHTML='<tr><td colspan="12"><div class="purchase-empty">Pirkimo užsakymų nėra.</div></td></tr>';return}
  tb.innerHTML=arr.map(o=>{
    const c=orderCalc(o),pst=paymentStatus(o);
    const oq=(o.lines||[]).reduce((a,l)=>a+n(l.qty),0),got=(o.lines||[]).reduce((a,l)=>a+n(l.receivedQty),0);
    return`<tr>
      <td><div class="purchase-name">${esc(o.no)}</div><div class="purchase-meta">${esc([o.reference,o.documentName,window.MOGA_ACCOUNTING?.groupById?.(o.accountingGroup)?.name].filter(Boolean).join(' · '))}</div></td>
      <td>${esc(o.date||'—')}</td>
      <td><b>${esc(supplierNameFast(o))}</b><div class="purchase-meta">${esc(supplierContactFast(o))}</div></td>
      <td class="center"><span class="po-status ${esc(o.status)}">${esc(statusLabel(o.status))}</span></td>
      <td class="center">${oq.toLocaleString('lt-LT')}</td>
      <td class="center">${got.toLocaleString('lt-LT')}</td>
      <td class="center">${(oq-got).toLocaleString('lt-LT')}</td>
      <td class="money">${money(c.total)}</td>
      <td class="center"><span class="pay-status ${pst}">${payLabel(pst)}</span></td>
      <td>${esc(o.expectedDate||'—')}</td>
      <td>${esc(o.tracking||'—')}</td>
      <td><div class="purchase-actions">
        ${o.documentBlobId?`<button class="purchase-icon doc" title="Peržiūrėti PDF" onclick="MOGA_DOCUMENTS.view('${o.documentBlobId}')">◉</button><button class="purchase-icon download" title="Atsisiųsti PDF" onclick="MOGA_DOCUMENTS.download('${o.documentBlobId}')">⇩</button>`:(o.documentName?`<button class="purchase-icon doc" disabled title="Senas įrašas – PDF turinys anksčiau nebuvo archyvuojamas">◉</button>`:'')}
        <button class="purchase-icon edit" title="Redaguoti" onclick="openPurchaseOrder('${o.id}')">✎</button>
        <button class="purchase-icon receive" title="Priimti prekes" onclick="openReceipt('${o.id}')" ${o.status==='cancelled'||o.status==='received'?'disabled':''}>⇩</button>
        <button class="purchase-icon copy" title="Kopijuoti užsakymą" onclick="copyPurchaseOrder('${o.id}')">⧉</button>
        <button class="purchase-icon delete" title="Panaikinti" onclick="deletePurchaseOrder('${o.id}')">×</button>
      </div></td>
    </tr>`;
  }).join('');
}
window.renderPurchaseOrders=renderOrders;

function renderSuppliers(){
  renderKpis();
  const supplierSearchEl=document.getElementById('supplierSearch');if(supplierSearchEl&&!supplierSearchEl.placeholder)supplierSearchEl.placeholder='Paieška';
  const q=norm(document.getElementById('supplierSearch')?.value);
  const onlyActive=!!document.getElementById('supplierActiveOnly')?.checked;
  const arr=suppliers().filter(s=>{
    if(onlyActive&&s.active===false)return false;
    return!q||norm([s.name,s.companyCode,s.vatCode,s.contactName,s.email,s.phone,s.website].join(' ')).includes(q);
  }).sort((a,b)=>a.name.localeCompare(b.name,'lt'));
  const wrap=document.getElementById('supplierGrid');if(!wrap)return;
  if(!arr.length){wrap.innerHTML='<div class="purchase-empty">Tiekėjų nėra.</div>';return}
  wrap.innerHTML=arr.map(s=>`<article class="supplier-card ${s.active===false?'inactive':''}">
    <div class="supplier-card-top"><div><h4>${esc(s.name)}</h4><div class="supplier-sub">${esc([s.companyCode,s.vatCode].filter(Boolean).join(' · ')||'Be įmonės rekvizitų')}</div></div><span class="po-status ${s.active===false?'cancelled':'received'}">${s.active===false?'NEAKTYVUS':'AKTYVUS'}</span></div>
    <div class="supplier-sub" style="margin-top:8px">${esc([s.contactName,s.phone,s.email].filter(Boolean).join(' · ')||'Kontaktai nenurodyti')}</div>
    <div class="supplier-card-stats">
      <div class="supplier-card-stat"><span>Prekės</span><b>${supplierLinksCount(s.id)}</b></div>
      <div class="supplier-card-stat"><span>Atviri PO</span><b>${supplierOpen(s.id)}</b></div>
      <div class="supplier-card-stat"><span>Pirkimai</span><b>${money(supplierSpend(s.id))}</b></div>
    </div>
    <div class="supplier-card-actions">
      <button onclick="openSupplier('${s.id}')">REDAGUOTI</button>
      <button onclick="openSupplierLink(null,'${s.id}')">+ PREKĖ</button>
      <button onclick="newPurchaseOrder('${s.id}')">+ PO</button>
      <button onclick="deleteSupplier('${s.id}')" style="background:#b00000;color:#fff;border-color:#b00000">IŠTRINTI</button>
    </div>
  </article>`).join('');
}
window.renderSuppliers=renderSuppliers;


let supplierLinkTableSelected=new Set();

function ensureSupplierLinksBulkUi(){
  const tb=document.getElementById('supplierLinkBody');
  const table=tb?.closest('table');
  const tr=table?.querySelector('thead tr');
  if(tr&&!tr.querySelector('[data-supplier-link-select-head]')){
    const th=document.createElement('th');
    th.dataset.supplierLinkSelectHead='1';
    th.className='supplier-link-select-col';
    th.innerHTML='<input id="supplierLinkSelectVisible" type="checkbox" title="Pažymėti / atžymėti visas rodomas">';
    tr.insertBefore(th,tr.firstElementChild);
    th.querySelector('input').addEventListener('change',e=>toggleVisibleSupplierLinks(!!e.target.checked));
  }

  if(table&&!document.getElementById('supplierLinkBulkDelete')){
    const bar=document.createElement('div');
    bar.id='supplierLinkBulkBar';
    bar.className='supplier-link-bulk-bar';
    const btn=document.createElement('button');
    btn.id='supplierLinkBulkDelete';
    btn.type='button';
    btn.textContent='IŠTRINTI PAŽYMĖTUS';
    btn.className='supplier-link-bulk-delete';
    btn.onclick=deleteSelectedSupplierLinks;
    bar.appendChild(btn);
    const wrap=table.parentElement||table;
    wrap.parentElement?.insertBefore(bar,wrap);
  }
}
function currentVisibleSupplierLinks(){
  const q=norm(document.getElementById('supplierLinkSearch')?.value);
  const sid=document.getElementById('supplierLinkSupplierFilter')?.value||'all';
  return links().filter(l=>{
    const p=product(l.productId),sp=supplier(l.supplierId);
    if(sid!=='all'&&l.supplierId!==sid)return false;
    return!q||norm([p?.name,p?.sku,sp?.name,l.supplierSku,l.supplierName].join(' ')).includes(q);
  });
}
function updateSupplierLinksBulkUi(){
  const btn=document.getElementById('supplierLinkBulkDelete');
  const bar=document.getElementById('supplierLinkBulkBar');
  if(btn){
    if(bar)bar.style.display=supplierLinkTableSelected.size?'flex':'none';
    btn.textContent=supplierLinkTableSelected.size?`IŠTRINTI PAŽYMĖTUS (${supplierLinkTableSelected.size})`:'IŠTRINTI PAŽYMĖTUS';
  }
  const vis=currentVisibleSupplierLinks();
  const chk=document.getElementById('supplierLinkSelectVisible');
  if(chk){
    const count=vis.filter(l=>supplierLinkTableSelected.has(String(l.id))).length;
    chk.checked=vis.length>0&&count===vis.length;
    chk.indeterminate=count>0&&count<vis.length;
  }
}
function toggleSupplierLinkTableSelection(idv,on){
  const id=String(idv||'');if(!id)return;
  if(on)supplierLinkTableSelected.add(id);else supplierLinkTableSelected.delete(id);
  updateSupplierLinksBulkUi();
}
window.toggleSupplierLinkTableSelection=toggleSupplierLinkTableSelection;
function toggleVisibleSupplierLinks(on){
  currentVisibleSupplierLinks().forEach(l=>on?supplierLinkTableSelected.add(String(l.id)):supplierLinkTableSelected.delete(String(l.id)));
  renderLinks();
}
window.toggleVisibleSupplierLinks=toggleVisibleSupplierLinks;

async function deleteSelectedSupplierLinks(){
  const ids=[...supplierLinkTableSelected];
  if(!ids.length)return;
  const ok=await MOGA_UI.confirm(
    `Ištrinti ${ids.length} pažymėtus tiekėjo prekių susiejimus?\n\nPrekės iš katalogo nebus ištrintos — bus pašalinti tik tiekėjo susiejimai.`,
    {title:'Ištrinti pažymėtus susiejimus?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad noriu pašalinti pažymėtus susiejimus',confirmText:'IŠTRINTI'}
  );
  if(!ok)return;
  const doomed=new Set(ids);
  setLinks(links().filter(x=>!doomed.has(String(x.id))));
  supplierLinkTableSelected.clear();
  renderLinks();renderReorder();renderSuppliers();renderKpis();
  try{window.renderOverview?.();}catch(_){}
  try{window.MOGA_NOTIFICATIONS?.refresh?.();}catch(_){}
}
window.deleteSelectedSupplierLinks=deleteSelectedSupplierLinks;


const SUPPLIER_LINK_SORT_KEY='moga_supplier_links_sort_v2';

function supplierLinkSortState(){
  try{
    const raw=JSON.parse(localStorage.getItem(SUPPLIER_LINK_SORT_KEY)||'null');
    if(raw&&raw.field)return{field:raw.field,dir:raw.dir||'asc'};
  }catch(_){}
  return{field:'name',dir:'asc'};
}
function setSupplierLinkSort(field,dir){
  const st={field:String(field||'name'),dir:String(dir||'asc')};
  try{localStorage.setItem(SUPPLIER_LINK_SORT_KEY,JSON.stringify(st))}catch(_){}
  closeSupplierLinkSortMenu();
  renderLinks();
}
window.setSupplierLinkSort=setSupplierLinkSort;

function supplierLinkSortLabel(){
  const st=supplierLinkSortState();
  const names={name:'Pavadinimas',price:'Kaina',date:'Įkėlimo data'};
  return names[st.field]||'Pavadinimas';
}
function supplierLinkSortBadge(){
  const st=supplierLinkSortState();
  if(st.field==='name')return st.dir==='asc'?'A':'Z';
  if(st.field==='price')return st.dir==='asc'?'1':'9';
  return st.dir==='asc'?'↑':'↓';
}
function ensureSupplierLinkSortUi(){
  const supplierSel=document.getElementById('supplierLinkSupplierFilter');
  if(!supplierSel)return;

  let wrap=document.getElementById('supplierLinkSortWrap');
  if(!wrap){
    wrap=document.createElement('div');
    wrap.id='supplierLinkSortWrap';
    wrap.className='supplier-link-sort-wrap';
    wrap.innerHTML=`
      <button id="supplierLinkSortButton" type="button" class="supplier-link-sort-button" aria-expanded="false">
        <span class="supplier-link-sort-label"></span>
        <span class="supplier-link-sort-badge"></span>
        <span class="supplier-link-sort-caret">▼</span>
      </button>
      <div id="supplierLinkSortMenu" class="supplier-link-sort-menu">
        <div class="supplier-link-sort-row">
          <span>Pavadinimas</span>
          <div><button type="button" data-sort-field="name" data-sort-dir="asc">A</button><button type="button" data-sort-field="name" data-sort-dir="desc">Z</button></div>
        </div>
        <div class="supplier-link-sort-row">
          <span>Kaina</span>
          <div><button type="button" data-sort-field="price" data-sort-dir="asc">1</button><button type="button" data-sort-field="price" data-sort-dir="desc">9</button></div>
        </div>
        <div class="supplier-link-sort-row">
          <span>Įkėlimo data</span>
          <div><button type="button" data-sort-field="date" data-sort-dir="asc">↑</button><button type="button" data-sort-field="date" data-sort-dir="desc">↓</button></div>
        </div>
      </div>`;
    supplierSel.insertAdjacentElement('afterend',wrap);

    wrap.querySelector('#supplierLinkSortButton').addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const menu=wrap.querySelector('#supplierLinkSortMenu');
      menu.classList.toggle('open');
      wrap.querySelector('#supplierLinkSortButton').setAttribute('aria-expanded',menu.classList.contains('open')?'true':'false');
    });
    wrap.querySelectorAll('[data-sort-field]').forEach(btn=>btn.addEventListener('click',()=>{
      setSupplierLinkSort(btn.dataset.sortField,btn.dataset.sortDir);
    }));
  }

  const st=supplierLinkSortState();
  wrap.querySelector('.supplier-link-sort-label').textContent=supplierLinkSortLabel();
  wrap.querySelector('.supplier-link-sort-badge').textContent=supplierLinkSortBadge();
  wrap.querySelectorAll('[data-sort-field]').forEach(btn=>{
    btn.classList.toggle('active',btn.dataset.sortField===st.field&&btn.dataset.sortDir===st.dir);
  });
}
function closeSupplierLinkSortMenu(){
  const menu=document.getElementById('supplierLinkSortMenu');
  if(menu)menu.classList.remove('open');
  document.getElementById('supplierLinkSortButton')?.setAttribute('aria-expanded','false');
}
document.addEventListener('mousedown',e=>{
  const wrap=document.getElementById('supplierLinkSortWrap');
  if(wrap&&!wrap.contains(e.target))closeSupplierLinkSortMenu();
},true);

function naturalTextParts(v){
  return String(v||'').toLocaleLowerCase('lt-LT').match(/\d+(?:[.,]\d+)?|[^\d]+/g)||[];
}
function naturalTextCompare(a,b){
  const A=naturalTextParts(a),B=naturalTextParts(b),len=Math.max(A.length,B.length);
  for(let i=0;i<len;i++){
    if(i>=A.length)return-1;
    if(i>=B.length)return 1;
    const ax=A[i],bx=B[i];
    const an=/^\d/.test(ax),bn=/^\d/.test(bx);
    if(an&&bn){
      const av=Number(ax.replace(',','.')),bv=Number(bx.replace(',','.'));
      if(av!==bv)return av-bv;
    }else{
      const c=ax.localeCompare(bx,'lt',{sensitivity:'base',numeric:true});
      if(c)return c;
    }
  }
  return 0;
}

function renderLinks(){
  renderKpis();
  ensureSupplierLinksBulkUi();
  ensureSupplierLinkSortUi();
  const supplierLinkSearchEl=document.getElementById('supplierLinkSearch');if(supplierLinkSearchEl&&!supplierLinkSearchEl.placeholder)supplierLinkSearchEl.placeholder='Paieška';
  const q=norm(document.getElementById('supplierLinkSearch')?.value);
  const sid=document.getElementById('supplierLinkSupplierFilter')?.value||'all';

  /* Greitas snapshotas: šitam renderiui katalogą ir tiekėjus skaitom tik po 1 kartą. */
  const prod=products();
  const productMap=new Map(prod.map(x=>[String(x.inventoryId||''),x]));
  const productFast=id=>productMap.get(String(id||''))||null;
  const sup=suppliers();
  const supplierMap=new Map(sup.map(x=>[String(x.id||''),x]));
  const supplierFast=id=>supplierMap.get(String(id||''))||null;
  const effectiveCostFast=l=>{
    const linked=Math.max(0,n(l?.unitCost));
    return linked>0?linked:Math.max(0,n(productFast(l?.productId)?.cost));
  };

  const sel=document.getElementById('supplierLinkSupplierFilter');
  if(sel){
    const cur=sel.value||'all';
    sel.innerHTML='<option value="all">Visi tiekėjai</option>'+sup.map(x=>`<option value="${x.id}">${esc(x.name)}</option>`).join('');
    sel.value=sup.some(x=>x.id===cur)?cur:'all';
  }
  const all=links();
  const best=new Map();
  all.forEach(l=>{const c=effectiveCostFast(l);if(!best.has(l.productId)||c<best.get(l.productId))best.set(l.productId,c)});
  let arr=all.filter(l=>{
    const p=productFast(l.productId),sp=supplierFast(l.supplierId);
    if(sid!=='all'&&l.supplierId!==sid)return false;
    return!q||norm([p?.name,p?.sku,sp?.name,l.supplierSku,l.supplierName].join(' ')).includes(q);
  });

  const sortState=supplierLinkSortState();
  arr.sort((a,b)=>{
    let d=0;
    if(sortState.field==='date'){
      const ad=String(a.createdAt||a.updatedAt||a.id||'');
      const bd=String(b.createdAt||b.updatedAt||b.id||'');
      d=ad.localeCompare(bd);
    }else if(sortState.field==='price'){
      d=effectiveCostFast(a)-effectiveCostFast(b);
    }else{
      d=naturalTextCompare(productFast(a.productId)?.name||'',productFast(b.productId)?.name||'');
    }
    if(Math.abs(d)<0.00001)d=naturalTextCompare(productFast(a.productId)?.name||'',productFast(b.productId)?.name||'');
    return sortState.dir==='desc'?-d:d;
  });
  const tb=document.getElementById('supplierLinkBody');if(!tb)return;
  if(!arr.length){tb.innerHTML='<tr><td colspan="12"><div class="purchase-empty">Susietų tiekėjo prekių nėra.</div></td></tr>';updateSupplierLinksBulkUi();return}
  tb.innerHTML=arr.map(l=>{
    const p=productFast(l.productId),sp=supplierFast(l.supplierId),b=best.get(l.productId),cost=effectiveCostFast(l),change=n(l.previousCost)?((n(l.unitCost)-n(l.previousCost))/n(l.previousCost)*100):0;
    return`<tr>
      <td class="supplier-link-select-col"><input class="supplier-link-row-check" type="checkbox" ${supplierLinkTableSelected.has(String(l.id))?'checked':''} onchange="toggleSupplierLinkTableSelection('${esc(l.id)}',this.checked)"></td>
      <td><div class="purchase-name">${esc(p?.name||'Prekė pašalinta')}</div><div class="purchase-meta">${esc(p?.sku||'')}</div></td>
      <td>${esc(sp?.name||'Tiekėjas pašalintas')}</td>
      <td>${esc(l.supplierName||'—')}</td>
      <td>${esc(l.supplierSku||'—')}</td>
      <td class="money ${Math.abs(cost-b)<0.00001?'supplier-cost-best':''}">${money(cost)}</td>
      <td class="center">${n(l.moq)||1}</td>
      <td class="center">${n(l.packSize)||1}</td>
      <td class="center">${n(l.leadDays)||n(sp?.leadDays)||0} d.</td>
      <td class="center">${l.preferred?'<span class="preferred-star">★</span>':'—'}</td>
      <td class="center">${l.previousCost?`<span class="purchase-price-change ${change>0?'up':'down'}">${change>0?'+':''}${change.toFixed(1)}%</span>`:'—'}</td>
      <td><div class="purchase-actions">
        <button class="purchase-icon edit" onclick="openSupplierLink('${l.id}')">✎</button>
        <button class="purchase-icon delete" onclick="deleteSupplierLink('${l.id}')">×</button>
      </div></td>
    </tr>`;
  }).join('');
  updateSupplierLinksBulkUi();
}
window.renderSupplierLinks=renderLinks;

function preferredLink(productId){
  const all=links().filter(x=>x.productId===productId);
  return all.find(x=>x.preferred)||all.sort((a,b)=>n(a.unitCost)-n(b.unitCost))[0]||null;
}
function reorderRows(){
  const mult=Math.max(1,n(settings().targetMultiplier)||2);

  /* REIKIA UŽSAKYTI anksčiau kiekvienai prekei iš naujo skaitė orders/links/inventory.
     Dabar visus sunkius duomenis susidedam į Map vieną kartą. */
  const prod=products();
  const os=orders();
  const allLinks=links();
  const sup=suppliers();
  const supplierMap=new Map(sup.map(x=>[String(x.id||''),x]));

  const incomingMap=new Map();
  os.forEach(o=>{
    if(['draft','received','cancelled'].includes(o.status))return;
    (o.lines||[]).forEach(l=>{
      const pid=String(l.productId||'');if(!pid)return;
      incomingMap.set(pid,(incomingMap.get(pid)||0)+remaining(l));
    });
  });

  const preferredMap=new Map();
  allLinks.forEach(l=>{
    const pid=String(l.productId||'');if(!pid)return;
    const cur=preferredMap.get(pid);
    if(!cur||l.preferred&&!cur.preferred||(!cur.preferred&&!l.preferred&&n(l.unitCost)<n(cur.unitCost)))preferredMap.set(pid,l);
  });

  return prod.map(p=>{
    const pid=String(p.inventoryId||'');
    const r=invRecord(p.inventoryId);
    const av=Math.max(0,n(r.qty)-n(r.reserved));
    const inc=incomingMap.get(pid)||0;
    const min=n(r.min);
    const projected=av+inc;
    const target=min>0?Math.max(min,Math.ceil(min*mult)):0;
    const need=target>0?Math.max(0,target-projected):0;
    const l=preferredMap.get(pid)||null;
    return{p,r,av,inc,projected,target,need,link:l,sp:l?supplierMap.get(String(l.supplierId||''))||null:null};
  }).filter(x=>x.need>0||((x.av<=0)&&n(x.r.min)>0));
}
function renderReorder(){
  renderKpis();
  const reorderSearchEl=document.getElementById('reorderSearch');if(reorderSearchEl&&!reorderSearchEl.placeholder)reorderSearchEl.placeholder='Paieška';
  const q=norm(document.getElementById('reorderSearch')?.value);
  const sid=document.getElementById('reorderSupplierFilter')?.value||'all';
  const sup=suppliers();
  const sel=document.getElementById('reorderSupplierFilter');
  if(sel){
    const cur=sel.value||'all';
    sel.innerHTML='<option value="all">Visi tiekėjai</option><option value="unlinked">Nesusieta</option>'+sup.map(x=>`<option value="${x.id}">${esc(x.name)}</option>`).join('');
    sel.value=(cur==='unlinked'||sup.some(x=>x.id===cur))?cur:'all';
  }
  let rows=reorderRows().filter(x=>{
    if(q&&!norm([x.p.name,x.p.sku,x.p.category,x.sp?.name].join(' ')).includes(q))return false;
    if(sid==='unlinked'&&x.link)return false;
    if(sid!=='all'&&sid!=='unlinked'&&x.link?.supplierId!==sid)return false;
    return true;
  });
  const tb=document.getElementById('reorderBody');if(!tb)return;
  if(!rows.length)tb.innerHTML='<tr><td colspan="10"><div class="purchase-empty">Šiuo metu automatinio papildymo pasiūlymų nėra.</div></td></tr>';
  else tb.innerHTML=rows.map(x=>`<tr>
    <td><div class="purchase-name">${esc(x.p.name)}</div><div class="purchase-meta">${esc([x.p.sku,x.p.category].filter(Boolean).join(' · '))}</div></td>
    <td class="center">${x.av.toLocaleString('lt-LT')}</td>
    <td class="center">${x.inc.toLocaleString('lt-LT')}</td>
    <td class="center">${x.projected.toLocaleString('lt-LT')}</td>
    <td class="center">${n(x.r.min).toLocaleString('lt-LT')}</td>
    <td class="center">${x.target.toLocaleString('lt-LT')}</td>
    <td class="center"><b>${x.need.toLocaleString('lt-LT')}</b></td>
    <td>${x.sp?esc(x.sp.name):'<span class="reorder-unlinked">NESUSIETA</span>'}</td>
    <td class="money">${x.link?money(x.link.unitCost):'—'}</td>
    <td>${x.link?`<button class="purchase-action" onclick="createOrderFromOneSuggestion('${x.p.inventoryId}')">SUKURTI PO</button>`:`<button class="purchase-action" onclick="openSupplierLink(null,null,'${x.p.inventoryId}')">SUSIETI</button>`}</td>
  </tr>`).join('');
  renderReorderSummary(rows);
}
function renderReorderSummary(rows){
  const box=document.getElementById('reorderSummary');if(!box)return;
  const groups=new Map();
  rows.forEach(x=>{
    const key=x.link?.supplierId||'unlinked';
    if(!groups.has(key))groups.set(key,{sp:x.sp,rows:[],value:0});
    const g=groups.get(key);g.rows.push(x);g.value+=x.link?n(x.link.unitCost)*x.need:0;
  });
  box.innerHTML=`<h3>Automatinė suvestinė</h3>`+[...groups.values()].map(g=>`<div class="reorder-supplier-group"><b><span>${esc(g.sp?.name||'Nesusietos prekės')}</span><span>${g.rows.length}</span></b><small>${g.sp?`Numatoma užsakymo vertė: ${money(g.value)}`:'Pirmiausia susiek prekes su tiekėjais.'}</small></div>`).join('')+
  `<button class="purchase-action gold" style="width:100%;margin-top:12px" onclick="createOrdersFromSuggestions()">SUKURTI PO PAGAL PASIŪLYMUS</button>`;
}
window.renderReorder=renderReorder;

function renderAnalytics(){
  renderKpis();
  const os=orders().filter(o=>o.status!=='cancelled');
  const bySupplier=new Map(),byProduct=new Map();
  os.forEach(o=>{
    const c=orderCalc(o),sk=supplierNameForOrder(o)||'Nežinomas';
    bySupplier.set(sk,(bySupplier.get(sk)||0)+c.total);
    (o.lines||[]).forEach(l=>{
      const p=product(l.productId),pk=p?.name||l.name||'Nežinoma';
      const x=byProduct.get(pk)||{qty:0,value:0};x.qty+=n(l.receivedQty);x.value+=n(l.receivedQty)*effectiveLineCost(o,l);byProduct.set(pk,x);
    });
  });
  const supplierRows=[...bySupplier.entries()].sort((a,b)=>b[1]-a[1]).slice(0,10);
  const maxS=Math.max(1,...supplierRows.map(x=>x[1]));
  document.getElementById('purchaseTopSuppliers').innerHTML=supplierRows.length?supplierRows.map(([name,val])=>`<div class="purchase-bar-row"><span>${esc(name)}</span><div class="purchase-bar-track"><div class="purchase-bar-fill" style="width:${val/maxS*100}%"></div></div><b>${money(val)}</b></div>`).join(''):'<div class="purchase-empty">Duomenų nėra.</div>';
  const productRows=[...byProduct.entries()].sort((a,b)=>b[1].value-a[1].value).slice(0,10);
  const maxP=Math.max(1,...productRows.map(x=>x[1].value));
  document.getElementById('purchaseTopProducts').innerHTML=productRows.length?productRows.map(([name,x])=>`<div class="purchase-bar-row"><span>${esc(name)}</span><div class="purchase-bar-track"><div class="purchase-bar-fill" style="width:${x.value/maxP*100}%"></div></div><b>${x.qty.toLocaleString('lt-LT')} / ${money(x.value)}</b></div>`).join(''):'<div class="purchase-empty">Duomenų nėra.</div>';

  const history=links().filter(l=>l.previousCost&&n(l.previousCost)!==n(l.unitCost)).sort((a,b)=>String(b.updatedAt||'').localeCompare(String(a.updatedAt||''))).slice(0,20);
  const tb=document.getElementById('purchaseCostHistoryBody');
  tb.innerHTML=history.length?history.map(l=>{
    const p=product(l.productId),sp=supplier(l.supplierId),old=n(l.previousCost),cur=n(l.unitCost),pct=old?((cur-old)/old*100):0;
    return`<tr><td>${esc(p?.name||'—')}</td><td>${esc(sp?.name||'—')}</td><td class="money">${money(old)}</td><td class="money">${money(cur)}</td><td class="center"><span class="purchase-price-change ${pct>0?'up':'down'}">${pct>0?'+':''}${pct.toFixed(1)}%</span></td><td>${esc(String(l.updatedAt||'').slice(0,10))}</td></tr>`;
  }).join(''):'<tr><td colspan="6"><div class="purchase-empty">Kainų pokyčių dar nėra.</div></td></tr>';
}
window.renderPurchaseAnalytics=renderAnalytics;

/* ---------------- Supplier modal ---------------- */
let editingSupplierId=null;
function openSupplier(sid=null){
  editingSupplierId=sid;
  const s=sid?supplier(sid):null;
  document.getElementById('supplierModalTitle').textContent=s?'REDAGUOTI TIEKĖJĄ':'NAUJAS TIEKĖJAS';
  const ids=['supName','supCompanyCode','supVatCode','supContact','supPhone','supEmail','supWebsite','supAddress','supCountry','supCurrency','supTerms','supLead','supNotes'];
  const vals=[s?.name||'',s?.companyCode||'',s?.vatCode||'',s?.contactName||'',s?.phone||'',s?.email||'',s?.website||'',s?.address||'',s?.country||'Lietuva',s?.currency||settings().currency||'EUR',s?.paymentTerms||'',s?.leadDays||'',s?.notes||''];
  ids.forEach((x,i)=>document.getElementById(x).value=vals[i]);
  document.getElementById('supActive').checked=s?.active!==false;
  document.getElementById('supplierModal').classList.add('open');
}
window.openSupplier=openSupplier;
function closeSupplier(){document.getElementById('supplierModal')?.classList.remove('open');editingSupplierId=null}
window.closeSupplier=closeSupplier;
function saveSupplier(){
  const name=document.getElementById('supName').value.trim();if(!name)return alert('Įrašyk tiekėjo pavadinimą.');
  const arr=suppliers(),old=editingSupplierId?supplier(editingSupplierId):null;
  const obj={...(old||{}),id:old?.id||id('sup'),name,
    companyCode:supCompanyCode.value.trim(),vatCode:supVatCode.value.trim(),contactName:supContact.value.trim(),phone:supPhone.value.trim(),
    email:supEmail.value.trim(),website:supWebsite.value.trim(),address:supAddress.value.trim(),country:supCountry.value.trim(),
    currency:supCurrency.value.trim()||'EUR',paymentTerms:supTerms.value.trim(),leadDays:n(supLead.value),notes:supNotes.value.trim(),
    active:supActive.checked,updatedAt:now(),createdAt:old?.createdAt||now()
  };
  const idx=arr.findIndex(x=>x.id===obj.id);if(idx>=0)arr[idx]=obj;else arr.push(obj);setSuppliers(arr);
  closeSupplier();renderSuppliers();renderOrders();renderLinks();renderReorder();
}
window.saveSupplier=saveSupplier;

async function deleteSupplier(sid){
  const s=supplier(sid);if(!s)return;

  const relatedOrders=orders().filter(o=>o.supplierId===sid);
  const relatedLinks=links().filter(l=>l.supplierId===sid);

  const msg=relatedOrders.length||relatedLinks.length
    ?`Tiekėjas „${s.name}“ turi susijusių duomenų:\n\nPirkimo užsakymų: ${relatedOrders.length}\nSusietų prekių: ${relatedLinks.length}\n\nIštrinti tiekėją iš aktyvios bazės?\n\nSeni pirkimo užsakymai ir jų istorija LIKS. Juose bus išsaugotas tiekėjo pavadinimas ir rekvizitai. Tiekėjo prekių susiejimai bus pašalinti.`
    :`Ištrinti tiekėją „${s.name}“?`;

  if(!(await MOGA_UI.confirm(msg,{title:'Ištrinti tiekėją?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad noriu ištrinti šį tiekėją',confirmText:'IŠTRINTI'})))return;

  /* Prieš ištrinant tiekėją į kiekvieną seną PO įrašome jo momentinę kopiją,
     kad istorijoje niekada nedingtų pavadinimas / rekvizitai. */
  const nextOrders=orders().map(o=>{
    if(o.supplierId!==sid)return o;
    return{
      ...o,
      supplierSnapshot:o.supplierSnapshot||{
        name:s.name||'',
        companyCode:s.companyCode||'',
        vatCode:s.vatCode||'',
        contactName:s.contactName||'',
        phone:s.phone||'',
        email:s.email||'',
        address:s.address||'',
        country:s.country||''
      },
      updatedAt:o.updatedAt||now()
    };
  });

  setOrders(nextOrders);
  setLinks(links().filter(l=>l.supplierId!==sid));
  setSuppliers(suppliers().filter(x=>x.id!==sid));

  renderSuppliers();
  renderOrders();
  renderLinks();
  renderReorder();
  renderAnalytics();
  renderKpis();
  window.renderOverview?.();
  window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.deleteSupplier=deleteSupplier;


/* ---------------- Supplier product link ---------------- */
let editingLinkId=null;
let supplierLinkSelected=new Set();
let supplierLinkInitialSelected=new Set();
function syncVisibleSupplierProductChecks(){
  document.querySelectorAll('#supplierLinkProducts input[type=checkbox]').forEach(cb=>{
    const id=String(cb.value||'');
    if(cb.checked)supplierLinkSelected.add(id);else supplierLinkSelected.delete(id);
  });
}
function supplierProductFilteredRows(){
  const q=norm(document.getElementById('supplierLinkProductSearch')?.value||'');
  const cat=document.getElementById('supplierLinkCategory')?.value||'all';
  return products().filter(x=>{
    if(q&&!norm([x.name,x.sku,x.category].join(' ')).includes(q))return false;
    if(cat!=='all'&&String(x.category||'')!==cat)return false;
    return true;
  });
}

function updateSupplierLinkSelectionUi(){
  const count=document.getElementById('supplierLinkSelectedCount');
  if(count)count.textContent=`Pažymėta: ${supplierLinkSelected.size}`;
  const btn=document.getElementById('supplierLinkSelectFiltered');
  if(btn){
    const rows=supplierProductFilteredRows();
    const all=rows.length&&rows.every(x=>supplierLinkSelected.has(String(x.inventoryId)));
    btn.textContent=all?'ATŽYMĖTI RODOMUS':'PASIRINKTI VISUS';
  }
}

function renderSupplierProductChecklist(selected=null){
  const root=document.getElementById('supplierLinkProducts');if(!root)return;
  if(Array.isArray(selected))supplierLinkSelected=new Set(selected.map(String).filter(Boolean));
  const prod=supplierProductFilteredRows();
  root.innerHTML=prod.length
    ?prod.map(x=>`<label class="supplier-product-choice"><input type="checkbox" value="${esc(x.inventoryId)}" ${supplierLinkSelected.has(String(x.inventoryId))?'checked':''}><span><b>${esc(x.name)}</b>${x.sku?`<small>${esc(x.sku)}</small>`:''}${x.category?`<small>${esc(x.category)}</small>`:''}</span></label>`).join('')
    :'<div class="purchase-meta" style="padding:12px">Prekių nerasta.</div>';
  root.querySelectorAll('input[type=checkbox]').forEach(cb=>cb.addEventListener('change',()=>{
    const id=String(cb.value||'');
    if(cb.checked)supplierLinkSelected.add(id);else supplierLinkSelected.delete(id);
    updateSupplierLinkSelectionUi();
  }));
  updateSupplierLinkSelectionUi();
}
window.renderSupplierProductChecklist=renderSupplierProductChecklist;

function ensureSupplierLinkCategoryUi(){
  const search=document.getElementById('supplierLinkProductSearch');
  const toolbar=search?.closest('.supplier-products-toolbar');
  if(!search||!toolbar)return;

  let controls=document.getElementById('supplierLinkExtraFilters');
  if(!controls){
    controls=document.createElement('div');
    controls.id='supplierLinkExtraFilters';
    controls.style.cssText='display:flex;gap:8px;align-items:end;flex-wrap:wrap;margin-top:8px;width:100%';

    const categoryWrap=document.createElement('label');
    categoryWrap.style.cssText='min-width:220px;display:flex;flex-direction:column;gap:5px;font-size:11px;font-weight:700';
    categoryWrap.innerHTML='<span>Kategorija</span><select id="supplierLinkCategory" style="width:100%;height:38px;border:1px solid #ccc;border-radius:8px;background:#fff;color:#111;padding:0 10px"></select>';

    const selectBtn=document.createElement('button');
    selectBtn.type='button';
    selectBtn.id='supplierLinkSelectFiltered';
    selectBtn.textContent='PASIRINKTI VISUS';
    selectBtn.style.cssText='height:38px;border:0;border-radius:999px;padding:0 16px;font-weight:900;cursor:pointer;background:linear-gradient(90deg,#ff8a00,#ff5a8a);color:#111;white-space:nowrap';

    const clearBtn=document.createElement('button');
    clearBtn.type='button';
    clearBtn.id='supplierLinkClearSelection';
    clearBtn.textContent='ATŽYMĖTI VISUS';
    clearBtn.style.cssText='height:38px;border:1px solid #555;border-radius:999px;padding:0 14px;font-weight:800;cursor:pointer;background:#222;color:#fff;white-space:nowrap';

    const count=document.createElement('span');
    count.id='supplierLinkSelectedCount';
    count.style.cssText='font-size:11px;font-weight:800;color:#666;padding:0 4px 10px';

    controls.append(categoryWrap,selectBtn,clearBtn,count);
    toolbar.appendChild(controls);

    categoryWrap.querySelector('select').addEventListener('change',()=>renderSupplierProductChecklist());

    selectBtn.addEventListener('click',()=>{
      syncVisibleSupplierProductChecks();
      const rows=supplierProductFilteredRows();
      const all=rows.length&&rows.every(x=>supplierLinkSelected.has(String(x.inventoryId)));
      rows.forEach(x=>{
        const id=String(x.inventoryId);
        if(all)supplierLinkSelected.delete(id);else supplierLinkSelected.add(id);
      });
      renderSupplierProductChecklist();
    });

    clearBtn.addEventListener('click',()=>{
      supplierLinkSelected.clear();
      renderSupplierProductChecklist();
    });
  }

  const sel=document.getElementById('supplierLinkCategory');
  if(sel){
    const current=sel.value||'all';
    const cats=[...new Set(products().map(p=>String(p.category||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt'));
    sel.innerHTML='<option value="all">Visos kategorijos</option>'+cats.map(c=>`<option value="${esc(c)}">${esc(c)}</option>`).join('');
    sel.value=cats.includes(current)?current:'all';
  }

  // Search should never clear selected IDs; it only rerenders the current view.
  search.oninput=()=>renderSupplierProductChecklist();

  if(!supplierLinkSupplier.dataset.selectionSyncBound){
    supplierLinkSupplier.dataset.selectionSyncBound='1';
    supplierLinkSupplier.addEventListener('change',()=>{
      if(editingLinkId)return;
      loadSupplierExistingSelection(supplierLinkSupplier.value);
    });
  }
  updateSupplierLinkSelectionUi();
}
window.ensureSupplierLinkCategoryUi=ensureSupplierLinkCategoryUi;
function supplierLinkedProductIds(sid){
  return links().filter(l=>String(l.supplierId||'')===String(sid||'')).map(l=>String(l.productId||'')).filter(Boolean);
}
function loadSupplierExistingSelection(sid){
  const ids=supplierLinkedProductIds(sid);
  supplierLinkInitialSelected=new Set(ids);
  supplierLinkSelected=new Set(ids);
  renderSupplierProductChecklist();
}
function selectedSupplierProducts(){syncVisibleSupplierProductChecks();return [...supplierLinkSelected]}
window.selectedSupplierProducts=selectedSupplierProducts;
function openSupplierLink(linkId=null,supplierId=null,productId=null){
  editingLinkId=linkId;
  const l=linkId?linkById(linkId):null;
  const sup=suppliers().filter(x=>x.active!==false||x.id===l?.supplierId);
  supplierLinkSupplier.innerHTML='<option value="">Pasirinkite tiekėją</option>'+sup.map(x=>`<option value="${x.id}">${esc(x.name)}</option>`).join('');
  supplierLinkSupplier.value=l?.supplierId||supplierId||'';
  ensureSupplierLinkCategoryUi();
  if(document.getElementById('supplierLinkProductSearch'))supplierLinkProductSearch.value='';
  if(document.getElementById('supplierLinkCategory'))supplierLinkCategory.value='all';
  if(l){
    supplierLinkInitialSelected=new Set([String(l.productId||'')].filter(Boolean));
    renderSupplierProductChecklist([l.productId].filter(Boolean));
  }else if(supplierLinkSupplier.value){
    loadSupplierExistingSelection(supplierLinkSupplier.value);
    if(productId){supplierLinkSelected.add(String(productId));renderSupplierProductChecklist();}
  }else{
    supplierLinkInitialSelected=new Set([String(productId||'')].filter(Boolean));
    renderSupplierProductChecklist([productId||''].filter(Boolean));
  }
  supplierLinkName.value=l?.supplierName||'';supplierLinkSku.value=l?.supplierSku||'';supplierLinkCost.value=l?.unitCost??'';supplierLinkMoq.value=l?.moq||1; supplierLinkPack.value=l?.packSize||1;supplierLinkLead.value=l?.leadDays||'';supplierLinkPreferred.checked=!!l?.preferred;supplierLinkNotes.value=l?.notes||'';
  const hint=document.getElementById('supplierLinkBulkHint');if(hint)hint.textContent=l?'Redaguojamas vienas susiejimas.':'Filtruok pagal kategoriją ar paiešką; pažymėjimai išlieka keičiant filtrus.';
  document.getElementById('supplierLinkModal').classList.add('open');
}
window.openSupplierLink=openSupplierLink;
function closeSupplierLink(){document.getElementById('supplierLinkModal')?.classList.remove('open');editingLinkId=null;supplierLinkSelected=new Set();supplierLinkInitialSelected=new Set()}
window.closeSupplierLink=closeSupplierLink;
function saveSupplierLink(){
  const sid=supplierLinkSupplier.value,pids=selectedSupplierProducts();
  if(!sid||!pids.length)return alert('Pasirink tiekėją ir bent vieną katalogo prekę.');

  const arr=links(),old=editingLinkId?linkById(editingLinkId):null,enteredCost=Math.max(0,n(supplierLinkCost.value)),created=[];
  if(old&&pids.length>1)return alert('Redaguojant esamą susiejimą galima pasirinkti vieną prekę.');

  if(old){
    const pid=pids[0],p=products().find(x=>String(x.inventoryId||'')===String(pid))||{};
    const catalogCost=Math.max(0,n(p.cost)),effectiveCost=enteredCost>0?enteredCost:catalogCost;
    if(supplierLinkPreferred.checked)arr.forEach(x=>{if(x.productId===pid)x.preferred=false});
    const obj={...old,supplierId:sid,productId:pid,supplierName:supplierLinkName.value.trim(),supplierSku:supplierLinkSku.value.trim(),previousCost:n(old.unitCost)!==effectiveCost?n(old.unitCost):(old.previousCost||null),unitCost:effectiveCost,moq:Math.max(1,n(supplierLinkMoq.value)||1),packSize:Math.max(1,n(supplierLinkPack.value)||1),leadDays:Math.max(0,n(supplierLinkLead.value)),preferred:supplierLinkPreferred.checked,notes:supplierLinkNotes.value.trim(),updatedAt:now()};
    const idx=arr.findIndex(x=>x.id===old.id);if(idx>=0)arr[idx]=obj;
  }else{
    /* Naujo susiejimo modalas veikia kaip tiekėjo narystės sinchronizavimas:
       jau susietos prekės pažymėtos; atžymėtos pašalinamos; naujai pažymėtos sukuriamos.
       Esamų susiejimų kainų/MOQ ir kitų duomenų neperrašome. */
    const selected=new Set(pids.map(String));
    const initial=new Set(supplierLinkInitialSelected);
    let next=arr.filter(x=>!(String(x.supplierId||'')===String(sid)&&initial.has(String(x.productId||''))&&!selected.has(String(x.productId||''))));

    selected.forEach(pid=>{
      const exists=next.find(x=>String(x.supplierId||'')===String(sid)&&String(x.productId||'')===String(pid));
      if(exists)return;
      const p=products().find(x=>String(x.inventoryId||'')===String(pid))||{};
      const catalogCost=Math.max(0,n(p.cost));
      const effectiveCost=enteredCost>0?enteredCost:catalogCost;
      const obj={id:id('spl'),supplierId:sid,productId:pid,supplierName:supplierLinkName.value.trim(),supplierSku:supplierLinkSku.value.trim(),previousCost:null,unitCost:effectiveCost,moq:Math.max(1,n(supplierLinkMoq.value)||1),packSize:Math.max(1,n(supplierLinkPack.value)||1),leadDays:Math.max(0,n(supplierLinkLead.value)),preferred:supplierLinkPreferred.checked,notes:supplierLinkNotes.value.trim(),updatedAt:now(),createdAt:now()};
      next.push(obj);created.push(obj);
    });
    setLinks(next);
    closeSupplierLink();
    renderLinks();renderReorder();renderSuppliers();renderKpis();refreshPurchaseProductSelect();
    try{window.renderOverview?.();}catch(_){}
    try{window.MOGA_NOTIFICATIONS?.refresh?.();}catch(_){}
    alert(`Tiekėjo prekių susiejimai atnaujinti. Naujai sukurta: ${created.length}.`);
    return;
  }

  setLinks(arr);
  closeSupplierLink();
  renderLinks();renderReorder();renderSuppliers();renderKpis();refreshPurchaseProductSelect();
  try{window.renderOverview?.();}catch(_){}
  try{window.MOGA_NOTIFICATIONS?.refresh?.();}catch(_){}
  alert('Susiejimas išsaugotas.');
}
window.saveSupplierLink=saveSupplierLink;
async function deleteSupplierLink(idv){
  if(!(await MOGA_UI.confirm('Panaikinti tiekėjo prekės susiejimą?',{title:'Panaikinti susiejimą?',danger:true,confirmText:'PANAIKINTI'})))return;
  setLinks(links().filter(x=>x.id!==idv));
  renderLinks();
  renderReorder();
  renderSuppliers();
  renderKpis();
  try{window.renderOverview?.();}catch(_){}
  try{window.MOGA_NOTIFICATIONS?.refresh?.();}catch(_){}
}
window.deleteSupplierLink=deleteSupplierLink;

/* ---------------- Purchase order modal ---------------- */
let editingOrderId=null,poLines=[];
function supplierOptions(selected=''){return suppliers().filter(x=>x.active!==false||x.id===selected).map(x=>`<option value="${x.id}" ${x.id===selected?'selected':''}>${esc(x.name)}</option>`).join('')}

let pendingPurchasePdf=null;
let removePurchasePdf=false;

function purchasePdfHash(file){
  try{return file.arrayBuffer().then(b=>crypto.subtle.digest('SHA-256',b)).then(h=>[...new Uint8Array(h)].map(x=>x.toString(16).padStart(2,'0')).join('')).catch(()=>'')}catch(_){return Promise.resolve('')}
}

function ensurePurchaseDocumentUi(){
  const modal=document.getElementById('purchaseOrderModal');
  const nameInput=document.getElementById('poDocumentName');
  if(!modal||!nameInput||document.getElementById('purchaseDocumentTools'))return;
  const host=nameInput.closest('label')||nameInput.parentElement;
  if(!host)return;
  const box=document.createElement('div');
  box.id='purchaseDocumentTools';
  box.style.cssText='display:flex;flex-wrap:wrap;gap:7px;margin-top:7px;align-items:center';
  box.innerHTML=`
    <input id="purchasePdfFile" type="file" accept="application/pdf,.pdf" hidden>
    <button type="button" id="purchasePdfAttach" style="border:1px solid #d8a03d;border-radius:999px;padding:7px 11px;background:#222;color:#fff;font-weight:800;cursor:pointer">PRISEGTI / PAKEISTI PDF</button>
    <button type="button" id="purchasePdfView" style="border:1px solid #d8a03d;border-radius:999px;padding:7px 11px;background:#dba400;color:#111;font-weight:800;cursor:pointer">PERŽIŪRĖTI</button>
    <button type="button" id="purchasePdfDownload" style="border:1px solid #1468d8;border-radius:999px;padding:7px 11px;background:#1468d8;color:#fff;font-weight:800;cursor:pointer">ATSISIŲSTI</button>
    <button type="button" id="purchasePdfRemove" style="border:1px solid #a90000;border-radius:999px;padding:7px 11px;background:#b40000;color:#fff;font-weight:800;cursor:pointer">PAŠALINTI PDF</button>
    <small id="purchasePdfState" style="flex-basis:100%;color:#777;font-size:10px;line-height:1.35"></small>`;
  host.appendChild(box);

  const fileEl=document.getElementById('purchasePdfFile');
  document.getElementById('purchasePdfAttach').onclick=()=>fileEl.click();
  fileEl.onchange=()=>{
    const f=fileEl.files?.[0];if(!f)return;
    if(!(f.type==='application/pdf'||/\.pdf$/i.test(f.name)))return alert('Galima prisegti tik PDF dokumentą.');
    if(f.size>25*1024*1024){fileEl.value='';return alert('PDF per didelis. Maksimalus vieno dokumento dydis – 25 MB.');}
    pendingPurchasePdf=f;removePurchasePdf=false;
    nameInput.value=f.name;
    updatePurchaseDocumentUi();
  };
  document.getElementById('purchasePdfView').onclick=()=>{
    if(pendingPurchasePdf){const u=URL.createObjectURL(pendingPurchasePdf);window.open(u,'_blank','noopener');setTimeout(()=>URL.revokeObjectURL(u),60000);return;}
    const o=editingOrderId?orderById(editingOrderId):null;if(o?.documentBlobId)window.MOGA_DOCUMENTS?.view?.(o.documentBlobId);
  };
  document.getElementById('purchasePdfDownload').onclick=()=>{
    if(pendingPurchasePdf){const u=URL.createObjectURL(pendingPurchasePdf),a=document.createElement('a');a.href=u;a.download=pendingPurchasePdf.name||'pirkimo-dokumentas.pdf';document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(u),1000);return;}
    const o=editingOrderId?orderById(editingOrderId):null;if(o?.documentBlobId)window.MOGA_DOCUMENTS?.download?.(o.documentBlobId);
  };
  document.getElementById('purchasePdfRemove').onclick=()=>{
    const o=editingOrderId?orderById(editingOrderId):null;
    if(!pendingPurchasePdf&&!o?.documentBlobId&&!o?.documentName)return;
    pendingPurchasePdf=null;removePurchasePdf=true;fileEl.value='';nameInput.value='';updatePurchaseDocumentUi();
  };
}

function updatePurchaseDocumentUi(o=null){
  ensurePurchaseDocumentUi();
  o=o||(editingOrderId?orderById(editingOrderId):null);
  const state=document.getElementById('purchasePdfState'),view=document.getElementById('purchasePdfView'),down=document.getElementById('purchasePdfDownload'),rem=document.getElementById('purchasePdfRemove');
  if(!state)return;
  const archived=!!o?.documentBlobId&&!removePurchasePdf;
  const hasPending=!!pendingPurchasePdf;
  const legacy=!!o?.documentName&&!o?.documentBlobId&&!removePurchasePdf;
  state.textContent=hasPending?`Bus išsaugotas naujas PDF: ${pendingPurchasePdf.name}`:archived?`PDF archyvuotas sistemoje: ${o.documentName||'dokumentas.pdf'}`:legacy?`Senas įrašas turi tik failo pavadinimą. Prisek originalų PDF, kad jį būtų galima peržiūrėti ir įtraukti į pilną kopiją.`:'PDF nepridėtas.';
  if(view)view.disabled=!(hasPending||archived);
  if(down)down.disabled=!(hasPending||archived);
  if(rem)rem.disabled=!(hasPending||archived||legacy);
  [view,down,rem].filter(Boolean).forEach(b=>{b.style.opacity=b.disabled?'.38':'1';b.style.cursor=b.disabled?'not-allowed':'pointer'});
}

function newPurchaseOrder(sid=''){openPurchaseOrder(null,sid)}
window.newPurchaseOrder=newPurchaseOrder;
function openPurchaseOrder(oid=null,sid=''){
  editingOrderId=oid;
  pendingPurchasePdf=null;removePurchasePdf=false;
  const o=oid?orderById(oid):null;
  poSupplier.innerHTML='<option value="">Pasirinkite tiekėją</option>'+supplierOptions(o?.supplierId||sid);
  poSupplier.value=o?.supplierId||sid||'';
  poNo.value=o?.no||nextPoNo();
  poDate.value=o?.date||today();poExpected.value=o?.expectedDate||'';poStatus.value=o?.status||'draft';
  if(window.MOGA_ACCOUNTING?.fillGroupSelect)window.MOGA_ACCOUNTING.fillGroupSelect(poGroup,o?.accountingGroup||'');
  if(document.getElementById('poDocumentName'))poDocumentName.value=o?.documentName||'';
  poReference.value=o?.reference||'';poTracking.value=o?.tracking||'';poCurrency.value=o?.currency||settings().currency||'EUR';
  poShipping.value=o?.shipping||0;poOtherCosts.value=o?.otherCosts||0;poDiscount.value=o?.discount||0;poVatRate.value=o?.vatRate??settings().defaultVatRate;
  poPricesIncludeVat.checked=!!o?.pricesIncludeVat;poPaid.value=o?.paidAmount||0;poNotes.value=o?.notes||'';
  ensurePurchaseSharedDocUi();
  if(document.getElementById('poSharedDocEnabled'))document.getElementById('poSharedDocEnabled').checked=!!o?.sharedDocumentEnabled;
  if(document.getElementById('poSharedDocKey'))document.getElementById('poSharedDocKey').value=o?.sharedDocumentKey||o?.reference||'';
  if(document.getElementById('poSharedDocTotal'))document.getElementById('poSharedDocTotal').value=o?.sharedDocumentTotal??'';
  if(document.getElementById('poSharedAllocated'))document.getElementById('poSharedAllocated').value=o?.sharedAllocatedAmount??'';
  refreshPurchaseSharedDocUi();
  poLines=(o?.lines||[]).map(x=>({...x}));
  ensurePoProductSearch();
  if(document.getElementById('poProductSearch')){document.getElementById('poProductSearch').value='';document.getElementById('poProductSearch').placeholder='Ieškoti susietos prekės...';}
  refreshPoProductPicker();renderPoLines();ensurePurchaseDocumentUi();updatePurchaseDocumentUi(o);ensurePoNewProductUi();document.getElementById('purchaseOrderModal').classList.add('open');
}
window.openPurchaseOrder=openPurchaseOrder;
window.openPurchaseOrderByNo=function(no){
  const o=orders().find(x=>String(x.no||'')===String(no||''));
  if(!o)return alert('Pirkimo užsakymas nerastas.');
  if(typeof switchPage==='function')switchPage('purchases');
  switchPane('orders');
  setTimeout(()=>openPurchaseOrder(o.id),0);
};
function closePurchaseOrder(){document.getElementById('purchaseOrderModal')?.classList.remove('open');editingOrderId=null;poLines=[];pendingPurchasePdf=null;removePurchasePdf=false;const f=document.getElementById('purchasePdfFile');if(f)f.value=''}
window.closePurchaseOrder=closePurchaseOrder;

function poProductSearchRows(){
  const sid=poSupplier.value;
  const q=norm(document.getElementById('poProductSearch')?.value||'');
  return links()
    .filter(x=>!sid||x.supplierId===sid)
    .map(l=>({l,p:product(l.productId)}))
    .filter(({l,p})=>{
      if(!p)return false;
      if(!q)return true;
      return norm([p.name,p.sku,p.category,l.supplierSku,l.supplierName].join(' ')).includes(q);
    });
}

function closePoProductResults(){
  const box=document.getElementById('poProductResults');
  if(box)box.style.display='none';
}

function selectPoProductSearchResult(linkId){
  const l=linkById(linkId),p=l?product(l.productId):null;
  if(!l||!p)return;
  poProductLink.value=l.id;
  const search=document.getElementById('poProductSearch');
  if(search)search.value=p.name;
  closePoProductResults();
  poAddQty?.focus?.();
}
window.selectPoProductSearchResult=selectPoProductSearchResult;

function renderPoProductResults(forceOpen=false){
  const search=document.getElementById('poProductSearch');
  const box=document.getElementById('poProductResults');
  if(!search||!box)return;

  const q=norm(search.value||'');
  const rows=poProductSearchRows();

  if(!q&&!forceOpen){
    box.style.display='none';
    return;
  }

  const visible=rows.slice(0,40);
  box.innerHTML=`
    <div style="padding:8px 11px;font-size:10px;font-weight:900;color:#777;border-bottom:1px solid #e5e5e5;background:#fafafa">
      ${q?'RASTA':'VISOS SUSIETOS PREKĖS'}: ${rows.length}${rows.length>40?' · RODOMOS PIRMOS 40':''}
    </div>
    ${visible.length?visible.map(({l,p})=>`
      <button type="button" data-po-result="1"
        onclick="selectPoProductSearchResult('${esc(l.id)}')"
        style="display:grid;grid-template-columns:42px minmax(0,1fr) auto;align-items:center;gap:10px;width:100%;border:0;border-bottom:1px solid #eee;background:#fff;color:#111;text-align:left;padding:6px 11px;cursor:pointer;font-size:12px;line-height:1.25">
        ${p.shopifyImageUrl
          ?`<img src="${esc(p.shopifyImageUrl)}" alt="${esc(p.shopifyImageAlt||p.name||'')}" loading="lazy" style="width:42px;height:42px;display:block;object-fit:cover;border-radius:8px;border:1px solid #e5e5e5;background:#f5f5f5">`
          :`<span aria-hidden="true" style="width:42px;height:42px;display:flex;align-items:center;justify-content:center;border-radius:8px;border:1px solid #e5e5e5;background:#f6f6f6;color:#aaa;font-size:16px">—</span>`}
        <span style="min-width:0">
          <b style="display:block;white-space:normal;overflow-wrap:anywhere">${esc(p.name)}</b>
          ${l.supplierSku?`<small style="display:block;color:#777;margin-top:2px">${esc(l.supplierSku)}</small>`:''}
        </span>
        <span style="margin-left:10px;font-weight:800;white-space:nowrap;align-self:center">${money(typeof supplierLinkEffectiveCost==='function'?supplierLinkEffectiveCost(l):l.unitCost)}</span>
      </button>`).join(''):'<div style="padding:14px;color:#777;font-size:12px">Prekių nerasta.</div>'}
  `;
  box.style.display='block';
}

function ensurePoProductSearch(){
  const select=document.getElementById('poProductLink');
  const search=document.getElementById('poProductSearch');
  const results=document.getElementById('poProductResults');
  const toggle=document.getElementById('poProductDropdownToggle');
  if(!select||!search||!results)return;

  select.style.display='none';
  if(search.dataset.poReady==='1')return;
  search.dataset.poReady='1';

  search.placeholder='Ieškoti susietos prekės...';

  search.addEventListener('input',()=>{
    poProductLink.value='';
    renderPoProductResults();
  });

  search.addEventListener('focus',()=>{
    if(search.value.trim())renderPoProductResults(true);
  });

  search.addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      search.value='';
      poProductLink.value='';
      closePoProductResults();
      return;
    }
    if(e.key==='ArrowDown'){
      const first=document.querySelector('#poProductResults button[data-po-result]');
      if(first){e.preventDefault();first.focus();}
      return;
    }
    if(e.key==='Enter'){
      e.preventDefault();
      const rows=poProductSearchRows();
      if(rows.length===1)selectPoProductSearchResult(rows[0].l.id);
      else renderPoProductResults(true);
    }
  });

  document.addEventListener('mousedown',e=>{
    const combo=document.getElementById('poProductCombobox');
    if(combo&&!combo.contains(e.target))closePoProductResults();
  });
}
window.ensurePoProductSearch=ensurePoProductSearch;

function togglePoProductResults(){
  ensurePoProductSearch();
  const box=document.getElementById('poProductResults');
  if(!box)return;
  if(box.style.display==='block'){
    closePoProductResults();
    return;
  }
  renderPoProductResults(true);
  document.getElementById('poProductSearch')?.focus();
}
window.togglePoProductResults=togglePoProductResults;

function refreshPoProductPicker(){
  ensurePoProductSearch();
  const current=poProductLink.value;
  const rows=links().filter(x=>!poSupplier.value||x.supplierId===poSupplier.value).map(l=>({l,p:product(l.productId)})).filter(x=>x.p);
  poProductLink.innerHTML='<option value=""></option>'+rows.map(({l,p})=>`<option value="${l.id}">${esc(p.name)}</option>`).join('');
  if(rows.some(x=>x.l.id===current))poProductLink.value=current;

  const search=document.getElementById('poProductSearch');
  if(search&&document.activeElement===search&&search.value.trim())renderPoProductResults(true);
}
window.refreshPoProductPicker=refreshPoProductPicker;

/* =========================================================
   PIRKIMAI — greitas naujos SFAPP prekės sukūrimas tiesiai PO
   ========================================================= */
function ensurePoNewProductUi(){
  const modal=document.getElementById('purchaseOrderModal');
  if(!modal)return;
  if(!document.getElementById('poQuickNewProductStyle')){
    const st=document.createElement('style');
    st.id='poQuickNewProductStyle';
    st.textContent=`
      .po-quick-new-btn{margin-left:8px;border:0!important;background:linear-gradient(135deg,#ff8a00,#ff4b93)!important;color:#fff!important;font-weight:900!important;white-space:nowrap}
      .po-new-product-overlay{position:fixed;inset:0;z-index:2147483601;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;padding:16px}
      .po-new-product-modal{width:min(720px,calc(100vw - 24px));max-height:calc(100vh - 24px);overflow:auto;background:#111;color:#fff;border:1px solid #343434;border-radius:20px;box-shadow:0 25px 80px rgba(0,0,0,.55)}
      .po-new-product-head{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;padding:18px 20px;border-bottom:1px solid #2c2c2c}
      .po-new-product-head .eyebrow{font-size:10px;font-weight:1000;letter-spacing:.12em;color:#ff9a35;text-transform:uppercase}.po-new-product-head h3{margin:4px 0 0;font-size:20px;color:#fff!important}.po-new-product-head .close{width:36px;height:36px;border-radius:11px;border:1px solid #3c3c3c;background:#1c1c1c;color:#fff;font-size:22px;cursor:pointer}
      .po-new-product-body{padding:18px 20px}.po-new-product-note{margin:0 0 15px;padding:11px 12px;border-radius:12px;background:#201c16;border:1px solid #4a3821;color:#f4dfbf;font-size:12px;line-height:1.45}
      .po-new-product-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.po-new-product-grid label{display:flex;flex-direction:column;gap:6px;font-size:10px;font-weight:900;letter-spacing:.04em;color:#ddd}.po-new-product-grid label.wide{grid-column:1/-1}.po-new-product-grid input,.po-new-product-grid select{height:42px;border-radius:10px;border:1px solid #3b3b3b;background:#181818!important;color:#fff!important;-webkit-text-fill-color:#fff!important;caret-color:#fff;padding:0 11px;outline:none}.po-new-product-grid input:focus,.po-new-product-grid select:focus{background:#181818!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border-color:#ff7f2a;box-shadow:0 0 0 2px rgba(255,126,42,.14)}.po-new-product-grid input::selection{background:#ffb24d;color:#111;-webkit-text-fill-color:#111}.po-new-product-grid select option{background:#f3f3f3!important;color:#111!important}.po-new-product-grid select option:hover,.po-new-product-grid select option:focus,.po-new-product-grid select option:checked{background:#fff0c9!important;color:#111!important}
      .po-new-product-dup{display:none;margin-top:12px;padding:10px 12px;border-radius:10px;border:1px solid #773636;background:#2a1717;color:#ffb8b8;font-size:11px;line-height:1.4}.po-new-product-dup.show{display:block}
      .po-new-product-actions{display:flex;justify-content:flex-end;gap:10px;padding:0 20px 18px}.po-new-product-actions button{min-height:42px;padding:0 16px;border-radius:11px;font-weight:900;cursor:pointer}.po-new-product-actions .cancel{border:1px solid #3b3b3b;background:#1e1e1e;color:#ddd}.po-new-product-actions .save{border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#fff}
      @media(max-width:640px){.po-new-product-grid{grid-template-columns:1fr}.po-new-product-grid label.wide{grid-column:auto}.po-quick-new-btn{margin-left:0;margin-top:7px;width:100%}}
    `;
    document.head.appendChild(st);
  }
  const addBtn=modal.querySelector('button[onclick*="addPoLine"]');
  if(addBtn&&!document.getElementById('poQuickNewProductBtn')){
    const b=document.createElement('button');
    b.type='button';b.id='poQuickNewProductBtn';b.className='po-quick-new-btn';b.textContent='+ NAUJA PREKĖ';
    b.onclick=openPoNewProductModal;
    addBtn.insertAdjacentElement('afterend',b);
  }
}
window.ensurePoNewProductUi=ensurePoNewProductUi;

function poNewProductDuplicateState(){
  const name=String(document.getElementById('poNewProductName')?.value||'').trim();
  const sku=String(document.getElementById('poNewProductSku')?.value||'').trim();
  const hitName=name?products().find(p=>norm(p.name)===norm(name)):null;
  const hitSku=sku?products().find(p=>norm(p.sku)===norm(sku)):null;
  const box=document.getElementById('poNewProductDuplicate');
  if(!box)return {hitName,hitSku};
  const hits=[hitSku,hitName].filter(Boolean).filter((v,i,a)=>a.indexOf(v)===i);
  box.classList.toggle('show',!!hits.length);
  box.innerHTML=hits.length?`SFAPP jau yra panaši prekė: <b>${hits.map(x=>esc(x.name)+(x.sku?` · SKU ${esc(x.sku)}`:'')).join('<br>')}</b><br>Jei tai ta pati prekė, uždaryk šį langą ir pasirink ją paieškoje, kad nesusidarytų dublikatas.`:'';
  return {hitName,hitSku};
}

function openPoNewProductModal(){
  const sid=String(poSupplier?.value||'').trim();
  if(!sid)return window.MOGA_UI?.alert?.('Pirmiausia pasirink tiekėją pirkimo užsakyme.',{title:'NAUJA PREKĖ'})||alert('Pirmiausia pasirink tiekėją pirkimo užsakyme.');
  document.getElementById('poNewProductOverlay')?.remove();
  const cats=[...new Set(products().map(p=>String(p.category||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt'));
  const overlay=document.createElement('div');overlay.id='poNewProductOverlay';overlay.className='po-new-product-overlay';
  overlay.innerHTML=`<div class="po-new-product-modal" role="dialog" aria-modal="true">
    <div class="po-new-product-head"><div><div class="eyebrow">PIRKIMAI · NAUJA SFAPP PREKĖ</div><h3>Sukurti prekę ir pridėti į pirkimą</h3></div><button type="button" class="close" aria-label="Uždaryti">×</button></div>
    <div class="po-new-product-body">
      <p class="po-new-product-note">Prekė bus sukurta SFAPP kataloge su <b>0 vnt.</b> sandėlio likučiu ir iškart pridėta prie šio pirkimo. Likutis didės tik tada, kai vėliau realiai priimsi prekes.</p>
      <div class="po-new-product-grid">
        <label class="wide">PAVADINIMAS *<input id="poNewProductName" autocomplete="off" placeholder="Pvz. Graviruojamas kaulo formos pakabukas – juodas"></label>
        <label>SKU / KODAS<input id="poNewProductSku" autocomplete="off" placeholder="Nebūtina"></label>
        <label>KATEGORIJA<input id="poNewProductCategory" list="poNewProductCategories" autocomplete="off" placeholder="Pvz. Graviravimo ruošiniai"><datalist id="poNewProductCategories">${cats.map(x=>`<option value="${esc(x)}"></option>`).join('')}</datalist></label>
        <label>MAT. VNT.<select id="poNewProductUnit"><option>vnt.</option><option>kompl.</option><option>pora</option><option>m</option><option>m²</option><option>kg</option><option>g</option><option>l</option><option>ml</option><option>lapas</option></select></label>
        <label>KIEKIS ŠIAME PIRKIME<input id="poNewProductQty" type="number" min="1" step="1" value="${Math.max(1,n(poAddQty?.value)||1)}"></label>
        <label>PIRKIMO VNT. KAINA<input id="poNewProductCost" type="number" min="0" step="0.0001" placeholder="0,00"></label>
        <label>PARDAVIMO KAINA<input id="poNewProductPrice" type="number" min="0" step="0.01" placeholder="Nebūtina"></label>
        <label>TIEKĖJO SKU / KODAS<input id="poNewProductSupplierSku" autocomplete="off" placeholder="Nebūtina"></label>
      </div>
      <div id="poNewProductDuplicate" class="po-new-product-dup"></div>
    </div>
    <div class="po-new-product-actions"><button type="button" class="cancel">ATŠAUKTI</button><button type="button" class="save">SUKURTI IR PRIDĖTI</button></div>
  </div>`;
  document.body.appendChild(overlay);
  const close=()=>overlay.remove();overlay.querySelector('.close').onclick=close;overlay.querySelector('.cancel').onclick=close;overlay.addEventListener('pointerdown',e=>{if(e.target===overlay)close()});
  ['poNewProductName','poNewProductSku'].forEach(id=>document.getElementById(id)?.addEventListener('input',poNewProductDuplicateState));
  overlay.querySelector('.save').onclick=savePoNewProduct;
  setTimeout(()=>document.getElementById('poNewProductName')?.focus(),30);
}
window.openPoNewProductModal=openPoNewProductModal;

async function savePoNewProduct(){
  const sid=String(poSupplier?.value||'').trim();
  if(!sid)return;
  const name=String(document.getElementById('poNewProductName')?.value||'').trim();
  const sku=String(document.getElementById('poNewProductSku')?.value||'').trim();
  const category=String(document.getElementById('poNewProductCategory')?.value||'').trim();
  const unit=String(document.getElementById('poNewProductUnit')?.value||'vnt.').trim()||'vnt.';
  const qty=Math.max(1,Math.round(n(document.getElementById('poNewProductQty')?.value)||1));
  const cost=Math.max(0,n(document.getElementById('poNewProductCost')?.value));
  const price=Math.max(0,n(document.getElementById('poNewProductPrice')?.value));
  const supplierSku=String(document.getElementById('poNewProductSupplierSku')?.value||'').trim();
  if(!name)return window.MOGA_UI?.alert?.('Įrašyk prekės pavadinimą.',{title:'NAUJA PREKĖ'})||alert('Įrašyk prekės pavadinimą.');
  const {hitName,hitSku}=poNewProductDuplicateState();
  if(hitName||hitSku)return window.MOGA_UI?.alert?.('Tokia arba labai aiškiai sutampanti prekė jau yra SFAPP. Pasirink esamą prekę pirkimo paieškoje, kad nesusidarytų dublikatas.',{title:'PREKĖ JAU YRA'})||alert('Prekė jau yra SFAPP.');
  if(typeof window.setProducts!=='function')return alert('SFAPP prekių išsaugojimo funkcija nepasiekiama. Perkrauk puslapį ir bandyk dar kartą.');

  const inventoryId=`inv_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,10)}`;
  const base={inventoryId,name,sku,category,unit,price:price?String(price):'',cost:cost?String(cost):'',active:true,archived:false};
  let savedList;
  try{savedList=window.setProducts([...products(),base])||products();}catch(err){console.error(err);return alert('Nepavyko sukurti prekės: '+(err?.message||err));}
  const saved=(savedList||products()).find(p=>String(p.inventoryId||'')===inventoryId)||products().find(p=>norm(p.name)===norm(name)&&(!sku||norm(p.sku)===norm(sku)));
  if(!saved)return alert('Prekė nebuvo išsaugota SFAPP kataloge.');

  /* Nauja prekė sandėlyje egzistuoja, bet iki realaus priėmimo jos likutis visada 0. */
  try{window.MOGA_INVENTORY?.patchRecord?.(saved.inventoryId,{qty:0});}catch(err){console.error('Naujos prekės sandėlio kortelė',err);}

  let arr=links();
  let l=arr.find(x=>String(x.supplierId||'')===sid&&String(x.productId||'')===String(saved.inventoryId));
  if(!l){
    l={id:id('spl'),supplierId:sid,productId:saved.inventoryId,supplierName:'',supplierSku,previousCost:null,unitCost:cost,moq:1,packSize:1,leadDays:0,preferred:false,notes:'Sukurta tiesiai iš pirkimo užsakymo',updatedAt:now(),createdAt:now()};
    arr.push(l);setLinks(arr);
  }

  const existing=poLines.find(x=>x.productId===saved.inventoryId&&x.supplierLinkId===l.id);
  if(existing){existing.qty+=qty;if(cost>0)existing.unitCost=cost;}
  else poLines.push({id:id('pol'),productId:saved.inventoryId,supplierLinkId:l.id,name:saved.name,sku:saved.sku||'',supplierSku:l.supplierSku||'',qty,receivedQty:0,unitCost:cost,discount:0,notes:'',accountingGroup:document.getElementById('poGroup')?.value||''});

  document.getElementById('poNewProductOverlay')?.remove();
  renderPoLines();refreshPoProductPicker();renderLinks();renderReorder();renderSuppliers();renderKpis();
  try{window.MOGA_INVENTORY?.refresh?.();window.renderOverview?.();window.MOGA_NOTIFICATIONS?.refresh?.()}catch(_){ }
  const search=document.getElementById('poProductSearch');if(search)search.value='';if(poAddQty)poAddQty.value='';
  window.MOGA_UI?.alert?.(`Prekė „${name}“ sukurta SFAPP ir pridėta į šį pirkimą. Sandėlio likutis kol kas 0 ${unit}; jis padidės tik priėmus prekes.`,{title:'PREKĖ SUKURTA'})||alert('Prekė sukurta ir pridėta į pirkimą.');
}
window.savePoNewProduct=savePoNewProduct;

function poAccountingGroupOptions(selected=''){
  const acc=window.MOGA_ACCOUNTING;
  const groups=acc?.groups?.()||[];
  return `<option value="">Pagal bendrą PO grupę</option>`+groups.map(g=>`<option value="${esc(g.id)}" ${String(g.id)===String(selected||'')?'selected':''}>${esc(g.name||g.sheetName||g.id)}</option>`).join('');
}

function flashPoAddSuccess(){
  // Efektas TIK ant tikrojo „+ PRIDĖTI“ mygtuko, ne kiekio laukelio / dropdown rodyklės.
  const btn=document.querySelector('button[onclick*="addPoLine"]')
    || [...document.querySelectorAll('button')].find(b=>String(b.textContent||'').trim().includes('PRIDĖTI') && b.closest('#purchaseOrderModal'));
  if(!btn)return;
  if(!document.getElementById('poAddSuccessFxStyle')){
    const st=document.createElement('style');
    st.id='poAddSuccessFxStyle';
    st.textContent=`
      @keyframes poAddSuccessPop{0%{transform:scale(1);box-shadow:0 0 0 0 rgba(35,190,95,.55)}22%{transform:scale(1.12);box-shadow:0 0 0 9px rgba(35,190,95,.18)}55%{transform:scale(.98);box-shadow:0 0 0 15px rgba(35,190,95,0)}100%{transform:scale(1);box-shadow:none}}
      .po-add-success-fx{background:#20b95b!important;color:#fff!important;border-color:#159346!important;animation:poAddSuccessPop .72s cubic-bezier(.2,.8,.2,1);}
    `;
    document.head.appendChild(st);
  }
  clearTimeout(btn._poAddSuccessTimer);
  if(!btn.dataset.poAddNormalHtml)btn.dataset.poAddNormalHtml=btn.innerHTML;
  btn.classList.remove('po-add-success-fx');
  void btn.offsetWidth;
  btn.classList.add('po-add-success-fx');
  btn.innerHTML='✓ PRIDĖTA';
  btn._poAddSuccessTimer=setTimeout(()=>{
    btn.classList.remove('po-add-success-fx');
    btn.innerHTML=btn.dataset.poAddNormalHtml||'+ PRIDĖTI';
  },900);
}

function addPoLine(){
  const lid=poProductLink.value,l=linkById(lid);if(!l)return alert('Pasirink susietą tiekėjo prekę.');
  const p=product(l.productId);if(!p)return alert('Katalogo prekė nerasta.');
  const q=Math.max(1,n(poAddQty.value)||n(l.moq)||1);
  const existing=poLines.find(x=>x.productId===p.inventoryId&&x.supplierLinkId===l.id);
  if(existing)existing.qty+=q;
  else poLines.push({id:id('pol'),productId:p.inventoryId,supplierLinkId:l.id,name:p.name,sku:p.sku||'',supplierSku:l.supplierSku||'',qty:q,receivedQty:0,unitCost:(typeof supplierLinkEffectiveCost==='function'?supplierLinkEffectiveCost(l):n(l.unitCost)),discount:0,notes:'',accountingGroup:document.getElementById('poGroup')?.value||''});
  poAddQty.value='';renderPoLines();
  flashPoAddSuccess();
  const search=document.getElementById('poProductSearch');
  poProductLink.value='';
  closePoProductResults();
  if(search){search.value='';refreshPoProductPicker();search.focus();}
}
window.addPoLine=addPoLine;
function ensurePoLineGroupHeader(){
  const tb=document.getElementById('poLineBody');const table=tb?.closest('table');const tr=table?.querySelector('thead tr');
  if(tr){
    [...tr.children].forEach(th=>{if(String(th.textContent||'').trim().toLowerCase()==='pastaba')th.remove();});
  }
  if(!tr||tr.querySelector('[data-po-group-head]'))return;
  const th=document.createElement('th');th.textContent='Grupė';th.dataset.poGroupHead='1';
  const cells=[...tr.children];
  const before=cells[cells.length-2]||cells[cells.length-1]||null;
  tr.insertBefore(th,before);
}
function renderPoLines(){
  const tb=document.getElementById('poLineBody');if(!tb)return;
  ensurePoLineGroupHeader();
  if(!poLines.length)tb.innerHTML='<tr><td colspan="9"><div class="purchase-empty">Pridėkite bent vieną prekę.</div></td></tr>';
  else tb.innerHTML=poLines.map((l,i)=>`<tr>
    <td><b>${esc(l.name||product(l.productId)?.name||'—')}</b><div class="purchase-meta">${esc(l.supplierSku||l.sku||'')}</div></td>
    <td><input type="number" min="${n(l.receivedQty)}" step="1" value="${n(l.qty)}" onchange="updatePoLine(${i},'qty',this.value)"></td>
    <td class="center">${n(l.receivedQty)}</td>
    <td><input type="number" min="0" step="0.01" value="${n(l.unitCost).toFixed(2)}" onchange="updatePoLine(${i},'unitCost',this.value)"></td>
    <td><input type="number" min="0" max="100" step="0.1" value="${n(l.discount)}" onchange="updatePoLine(${i},'discount',this.value)"></td>
    <td class="money">${money(lineBase(l))}</td>
    <td><select class="po-line-group-select" onchange="updatePoLine(${i},'accountingGroup',this.value)">${poAccountingGroupOptions(l.accountingGroup||'')}</select></td>
    <td class="center">${remaining(l)}</td>
    <td class="center"><button class="po-line-del" onclick="deletePoLine(${i})">×</button></td>
  </tr>`).join('');
  renderPoTotals();
}
window.renderPoLines=renderPoLines;
function updatePoLine(i,k,v){if(!poLines[i])return;poLines[i][k]=k==='qty'||k==='unitCost'||k==='discount'?n(v):v;renderPoLines()}
window.updatePoLine=updatePoLine;
function deletePoLine(i){if(n(poLines[i]?.receivedQty)>0)return alert('Negalima pašalinti eilutės, iš kurios prekės jau priimtos.');poLines.splice(i,1);renderPoLines()}
window.deletePoLine=deletePoLine;
function draftFromForm(){
  const old=editingOrderId?orderById(editingOrderId):null;
  return{id:editingOrderId||id('po'),no:poNo.value.trim(),supplierId:poSupplier.value,date:poDate.value,expectedDate:poExpected.value,status:poStatus.value,
    reference:poReference.value.trim(),tracking:poTracking.value.trim(),accountingGroup:document.getElementById('poGroup')?.value||'',documentName:removePurchasePdf?'':(pendingPurchasePdf?.name||document.getElementById('poDocumentName')?.value.trim()||old?.documentName||''),documentHash:removePurchasePdf?'':(old?.documentHash||''),documentBlobId:removePurchasePdf?'':(old?.documentBlobId||''),currency:poCurrency.value.trim()||'EUR',shipping:n(poShipping.value),otherCosts:n(poOtherCosts.value),
    discount:n(poDiscount.value),vatRate:n(poVatRate.value),pricesIncludeVat:poPricesIncludeVat.checked,paidAmount:n(poPaid.value),notes:poNotes.value.trim(),
    sharedDocumentEnabled:!!document.getElementById('poSharedDocEnabled')?.checked,
    sharedDocumentKey:document.getElementById('poSharedDocEnabled')?.checked?(document.getElementById('poSharedDocKey')?.value||'').trim():'',
    sharedDocumentTotal:document.getElementById('poSharedDocEnabled')?.checked?Math.max(0,n(document.getElementById('poSharedDocTotal')?.value)):0,
    sharedAllocatedAmount:document.getElementById('poSharedDocEnabled')?.checked?Math.max(0,n(document.getElementById('poSharedAllocated')?.value)):0,lines:poLines};
}
function renderPoTotals(){
  const c=orderCalc(draftFromForm());
  poSubtotal.textContent=money(c.subtotal);poOrderDiscount.textContent='− '+money(c.orderDiscount);poExtras.textContent=money(c.shipping+c.other);poVat.textContent=money(c.vat);poGrandTotal.textContent=money(c.total);poOutstanding.textContent=money(c.outstanding);
}
window.renderPoTotals=renderPoTotals;
async function savePurchaseOrder(close=true){
  const o=draftFromForm();if(!o.no)return alert('Trūksta pirkimo užsakymo numerio.');if(!o.supplierId)return alert('Pasirink tiekėją.');if(!o.lines.length)return alert('Pridėkite bent vieną prekę.');
  if(o.sharedDocumentEnabled){
    if(!o.sharedDocumentKey)return alert('Įrašyk bendro dokumento ID / Nr.');
    if(o.sharedDocumentTotal<=0)return alert('Įrašyk visą bendro dokumento sumą.');
    if(o.sharedAllocatedAmount<=0)o.sharedAllocatedAmount=orderCalc(o).total;
    const alloc=sharedDocAllocated(o.sharedDocumentKey,editingOrderId||'');
    if(alloc.total+o.sharedAllocatedAmount>o.sharedDocumentTotal+0.005)
      return alert(`Bendro dokumento paskirstymas viršytų visą sumą.\n\nVisa suma: ${money(o.sharedDocumentTotal)}\nJau priskirta kitur: ${money(alloc.total)}\nŠiam pirkimui: ${money(o.sharedAllocatedAmount)}`);
  }
  const arr=orders(),old=editingOrderId?orderById(editingOrderId):null;
  o.createdAt=old?.createdAt||now();o.updatedAt=now();o.receipts=old?.receipts||[];
  const currentSupplier=supplier(o.supplierId);
  o.supplierSnapshot=old?.supplierSnapshot||{
    name:currentSupplier?.name||'',
    companyCode:currentSupplier?.companyCode||'',
    vatCode:currentSupplier?.vatCode||'',
    contactName:currentSupplier?.contactName||'',
    phone:currentSupplier?.phone||'',
    email:currentSupplier?.email||'',
    address:currentSupplier?.address||'',
    country:currentSupplier?.country||''
  };
  o.status=orderStatusAuto(o);
  const supplierName=supplier(o.supplierId)?.name||o.supplierSnapshot?.name||'',total=orderCalc(o).total,others=arr.filter(x=>x.id!==o.id);
  const exact=others.find(x=>o.reference&&norm(x.reference)===norm(o.reference)&&norm(supplierNameForOrder(x))===norm(supplierName));
  const possible=exact?null:others.find(x=>norm(supplierNameForOrder(x))===norm(supplierName)&&String(x.date||'')===String(o.date||'')&&Math.abs(orderCalc(x).total-total)<0.01);
  if(exact){
    const action=await MOGA_UI.confirm(`Jau yra pirkimas su tuo pačiu tiekėju ir tiekėjo dokumento / nuorodos numeriu.\n\nTiekėjas: ${supplierNameForOrder(exact)}\nDokumento Nr.: ${exact.reference||'—'}\nData: ${exact.date||'—'}\nSuma: ${money(orderCalc(exact).total)}\nPO: ${exact.no||'—'}\n\nDublikatas nebus sukurtas.`,{title:'TIKSLUS DUBLIKATAS',kicker:'APSKAITOS APSAUGA',confirmText:'ATIDARYTI ESAMĄ',cancelText:'ATŠAUKTI'});
    if(action===true){closePurchaseOrder();setTimeout(()=>openPurchaseOrder(exact.id),40);}return false;
  }
  if(possible){
    const action=await MOGA_UI.confirm(`Rastas labai panašus pirkimas.\n\nTiekėjas: ${supplierNameForOrder(possible)}\nData: ${possible.date||'—'}\nSuma: ${money(orderCalc(possible).total)}\nPO: ${possible.no||'—'}\n\nJei tai kitas realus pirkimas, galite tęsti.`,{title:'GALIMAS DUBLIKATAS',kicker:'APSKAITOS APSAUGA',confirmText:'VIS TIEK IŠSAUGOTI',altText:'ATIDARYTI ESAMĄ',cancelText:'ATŠAUKTI'});
    if(action==='alt'){closePurchaseOrder();setTimeout(()=>openPurchaseOrder(possible.id),40);return false;}if(action!==true)return false;
  }
  const previousBlobId=old?.documentBlobId||'';
  let newlyArchivedId='';
  try{
    if(removePurchasePdf){o.documentName='';o.documentHash='';o.documentBlobId='';}
    if(pendingPurchasePdf){
      if(!window.MOGA_DOCUMENTS?.putFile)throw new Error('Dokumentų archyvas nepasiekiamas.');
      const hash=await purchasePdfHash(pendingPurchasePdf);
      const rec=await window.MOGA_DOCUMENTS.putFile(pendingPurchasePdf,{name:pendingPurchasePdf.name,hash,linkedType:'purchase'});
      if(!rec?.id)throw new Error('PDF nepavyko išsaugoti dokumentų archyve.');
      newlyArchivedId=rec.id;o.documentBlobId=rec.id;o.documentHash=hash||rec.hash||'';o.documentName=pendingPurchasePdf.name;
    }
    const idx=arr.findIndex(x=>x.id===o.id);if(idx>=0)arr[idx]=o;else arr.push(o);setOrders(arr);
    if(previousBlobId&&previousBlobId!==o.documentBlobId)try{await window.MOGA_DOCUMENTS?.remove?.(previousBlobId)}catch(e){console.warn('Seno pirkimo PDF pašalinti nepavyko',e)}
  }catch(err){
    console.error('Pirkimo PDF išsaugojimo klaida',err);
    if(newlyArchivedId)try{await window.MOGA_DOCUMENTS?.remove?.(newlyArchivedId)}catch(_){ }
    return alert(`Pirkimas neišsaugotas, nes nepavyko saugiai išsaugoti PDF.

${err?.message||err}`);
  }
  editingOrderId=o.id;
  pendingPurchasePdf=null;removePurchasePdf=false;
  if(close)closePurchaseOrder();else updatePurchaseDocumentUi(o);
  renderAll();return o;
}
window.savePurchaseOrder=savePurchaseOrder;
function copyPurchaseOrder(oid){
  const o=orderById(oid);if(!o)return;
  const x={...o,id:id('po'),no:nextPoNo(),date:today(),expectedDate:'',status:'draft',paidAmount:0,tracking:'',reference:`Kopija iš ${o.no}`,documentName:'',documentHash:'',documentBlobId:'',createdAt:now(),updatedAt:now(),receipts:[],lines:(o.lines||[]).map(l=>({...l,id:id('pol'),receivedQty:0}))};
  setOrders([...orders(),x]);renderOrders();
}
window.copyPurchaseOrder=copyPurchaseOrder;

/* Savininko avarinis PO pašalinimas.
   Naudojamas tik tada, kai normalus anuliavimas negalimas dėl sandėlio/FIFO.
   SVARBU: sandėlio kiekiai, FIFO partijos ir katalogo savikainos NELIEČIAMI. */
function purchaseOwnerMode(){
  try{
    const api=window.MOGA_EMPLOYEE_ACCESS||window.MOGA_EMPLOYEES||window.MOGA_WORKER_ACCESS||null;

    if(api){
      if(typeof api.isOwner==='function')return !!api.isOwner();
      if(typeof api.currentEmployee==='function'){
        const e=api.currentEmployee();
        return !e||String(e.role||e.type||'').toLowerCase()==='owner'||e.owner===true;
      }
      if(typeof api.current==='function'){
        const e=api.current();
        return !e||String(e.role||e.type||'').toLowerCase()==='owner'||e.owner===true;
      }
      if(api.employee){
        const e=api.employee;
        return !e||String(e.role||e.type||'').toLowerCase()==='owner'||e.owner===true;
      }
    }

    /* Dabartinėje WEB versijoje darbuotojo sesijos nėra – pagrindinė licencijos
       sesija laikoma savininko darbo aplinka. */
    return true;
  }catch(_){
    return false;
  }
}

function purchaseOwnerDeleteAudit(o,reason){
  try{
    const key='moga_purchase_owner_delete_audit_v1';
    let rows=[];
    try{rows=JSON.parse(localStorage.getItem(key)||'[]');if(!Array.isArray(rows))rows=[]}catch(_){rows=[]}
    rows.push({
      id:'podel_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,7),
      purchaseId:o?.id||'',
      no:o?.no||'',
      supplier:supplierNameForOrder(o),
      total:orderCalc(o).total,
      paid:orderCalc(o).paid,
      outstanding:orderCalc(o).outstanding,
      receivedQty:(o?.lines||[]).reduce((a,l)=>a+n(l.receivedQty),0),
      reason:String(reason||'owner-force-delete'),
      deletedAt:now()
    });
    if(rows.length>200)rows=rows.slice(-200);
    localStorage.setItem(key,JSON.stringify(rows));
  }catch(e){console.warn('PO savininko trynimo audito išsaugoti nepavyko',e)}
}

async function ownerForceDeletePurchaseOrder(o,reason='blocked-reversal'){
  if(!o)return false;

  if(!purchaseOwnerMode()){
    await window.MOGA_UI?.alert?.(
      'Šį avarinį pirkimo įrašo pašalinimą gali atlikti tik savininkas.',
      {title:'TIK SAVININKUI'}
    );
    return false;
  }

  const c=orderCalc(o);
  const got=(o.lines||[]).reduce((a,l)=>a+n(l.receivedQty),0);

  const first=await MOGA_UI.confirm(
    `Normaliai anuliuoti ${o.no} negalima, nes priimtos prekės jau paveikė sandėlį / FIFO.\n\nSavininkas gali pašalinti TIK pirkimo įrašą iš PIRKIMŲ modulio.\n\nBus pašalinta:\n• pirkimo įrašas ${o.no}\n• jo skola ${money(c.outstanding)} iš pirkimų suvestinės\n\nNEBUS keičiama:\n• sandėlio kiekiai\n• FIFO partijos ir savikainos\n• prekių katalogas\n\nPriimta pagal šį PO: ${got} vnt.`,
    {
      title:'SAVININKO AVARINIS ŠALINIMAS',
      danger:true,
      requireCheck:true,
      checkText:'Suprantu, kad bus pašalintas tik pirkimo įrašas, o sandėlis ir FIFO liks nepakeisti',
      confirmText:'TĘSTI'
    }
  );
  if(!first)return false;

  const second=await MOGA_UI.confirm(
    `Galutinis patvirtinimas.\n\nTikrai pašalinti ${o.no} iš PIRKIMŲ istorijos neliečiant sandėlio ir FIFO?`,
    {
      title:'PATVIRTINTI ŠALINIMĄ',
      danger:true,
      requireCheck:true,
      checkText:`Patvirtinu savininko sprendimą pašalinti ${o.no}`,
      confirmText:'PAŠALINTI TIK ĮRAŠĄ'
    }
  );
  if(!second)return false;

  purchaseOwnerDeleteAudit(o,reason);

  /* ČIA TYČIA NĖRA fifoReverseSource / patchRecord / addMove.
     Pašalinamas tik PO apskaitos įrašas, todėl sandėlio ir savikainų būsena lieka 1:1. */
  setOrders(orders().filter(x=>x.id!==o.id));

  if(o.documentBlobId){
    try{await window.MOGA_DOCUMENTS?.remove?.(o.documentBlobId)}
    catch(e){console.warn('Pirkimo PDF pašalinti nepavyko',e)}
  }

  renderOrders();
  renderKpis();
  renderReorder();
  renderAnalytics();
  window.renderOverview?.();
  window.MOGA_NOTIFICATIONS?.refresh?.();

  await window.MOGA_UI?.alert?.(
    `${o.no} pašalintas tik iš PIRKIMŲ registro.\n\nSandėlio kiekiai, FIFO ir savikainos nepakeisti.`,
    {title:'ĮRAŠAS PAŠALINTAS'}
  );
  return true;
}

async function deletePurchaseOrder(oid){
  const o=orderById(oid);if(!o)return;
  const got=(o.lines||[]).reduce((a,l)=>a+n(l.receivedQty),0);

  if(got>0){
    const received=(o.lines||[]).filter(l=>n(l.receivedQty)>0);

    // Saugiklis: negalime atšaukti priėmimo, jei sandėlyje nebėra pakankamai vienetų.
    const missing=received.filter(l=>{
      const r=invRecord(l.productId);
      return n(r.qty)<n(l.receivedQty);
    });
    if(missing.length){
      const names=missing.map(l=>`${l.name||product(l.productId)?.name||'Prekė'}: sandėlyje ${n(invRecord(l.productId).qty)}, reikėtų nuimti ${n(l.receivedQty)}`).join('\n');
      if(!purchaseOwnerMode()){
        return window.MOGA_UI?.alert?.(
          `Negalima anuliuoti ir ištrinti ${o.no}, nes sandėlyje nebėra pakankamai priimtų prekių:\n\n${names}\n\nSavininkas gali naudoti avarinį „tik įrašo“ pašalinimą.`,
          {title:'ANULIAVIMAS BLOKUOJAMAS'}
        );
      }
      return ownerForceDeletePurchaseOrder(o,'inventory-insufficient-for-reversal');
    }

    window.MOGA_INVENTORY?.ensureFifoInitialized?.();
    const fifoBlocked=received.filter(l=>!window.MOGA_INVENTORY?.fifoCanReverseSource?.('purchase',o.no,l.productId,n(l.receivedQty)));
    if(fifoBlocked.length){
      const names=fifoBlocked.map(l=>l.name||product(l.productId)?.name||'Prekė').join('\n• ');
      if(!purchaseOwnerMode()){
        return window.MOGA_UI?.alert?.(
          `Negalima saugiai anuliuoti ${o.no}, nes bent dalis FIFO partijos jau panaudota arba priėmimas senesnis už FIFO istoriją.\n\n• ${names}\n\nAvarinis „tik įrašo“ pašalinimas skirtas tik savininkui.`,
          {title:'FIFO APSAUGA'}
        );
      }
      return ownerForceDeletePurchaseOrder(o,'fifo-reversal-blocked');
    }

    if(!(await MOGA_UI.confirm(`Prekės iš ${o.no} jau buvo priimtos į sandėlį (${got} vnt.).\n\nAnuliuojant priėmimą šie vienetai bus nuimti iš sandėlio, o pirkimo užsakymas ištrintas.`,{title:'Anuliuoti pirkimą ir priėmimą?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad noriu anuliuoti priėmimą ir ištrinti pirkimą',confirmText:'ANULIUOTI IR IŠTRINTI'})))return;

    received.forEach(l=>{
      const p=product(l.productId);if(!p)return;
      const inv=invRecord(p.inventoryId),before=n(inv.qty),qty=n(l.receivedQty),after=before-qty;
      if(!window.MOGA_INVENTORY?.fifoReverseSource?.('purchase',o.no,p.inventoryId,qty))throw new Error(`FIFO partijos anuliuoti nepavyko: ${p.name}`);
      window.MOGA_INVENTORY?.patchRecord?.(p.inventoryId,{qty:after});
      window.MOGA_INVENTORY?.addMove?.({
        productId:p.inventoryId,
        type:'Pirkimo anuliavimas',
        delta:-qty,
        before,
        after,
        reference:o.no,
        note:`Anuliuotas pirkimo priėmimas ir ištrintas ${o.no}`
      });
    });
  }else{
    if(!(await MOGA_UI.confirm(`Panaikinti ${o.no}?`,{title:'Panaikinti pirkimo užsakymą?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad noriu panaikinti šį pirkimo užsakymą',confirmText:'PANAIKINTI'})))return;
  }

  setOrders(orders().filter(x=>x.id!==oid));
  if(o.documentBlobId)try{await window.MOGA_DOCUMENTS?.remove?.(o.documentBlobId)}catch(e){console.warn('Pirkimo PDF pašalinti nepavyko',e)}
  window.MOGA_INVENTORY?.refresh?.();
  renderOrders();
  renderKpis();
  renderReorder();
  renderAnalytics();
  window.renderOverview?.();
  window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.deletePurchaseOrder=deletePurchaseOrder;
window.ownerForceDeletePurchaseOrder=ownerForceDeletePurchaseOrder;

/* ---------------- Receipt ---------------- */
let receiptOrderId=null;
function openReceipt(oid){
  const o=orderById(oid);if(!o)return;if(['received','cancelled'].includes(o.status))return;
  receiptOrderId=oid;
  const sp=supplier(o.supplierId);
  receiptTitle.textContent=`PRIĖMIMAS · ${o.no}`;
  receiptSupplier.textContent=sp?.name||'';
  receiptDate.value=today();receiptReference.value=o.reference||'';
  const rem=(o.lines||[]).map((l,index)=>({l,index})).filter(x=>remaining(x.l)>0);
  receiptLines.innerHTML=rem.length?rem.map(({l,index})=>`<div class="receive-line" data-line-id="${esc(l.id||'')}" data-line-index="${index}">
    <div><strong>${esc(l.name||product(l.productId)?.name||'—')}</strong><small>Užsakyta ${n(l.qty)} · jau gauta ${n(l.receivedQty)} · liko ${remaining(l)}</small></div>
    <input class="receive-qty" type="number" min="0" max="${remaining(l)}" step="1" value="${remaining(l)}" title="Gaunamas kiekis">
    <div class="center">iš ${remaining(l)}</div>
    <div class="receive-cost"><b>${money(effectiveLineCost(o,l))}</b><small style="display:block">apsk. savikaina</small></div>
  </div>`).join(''):'<div class="purchase-empty">Visos prekės jau priimtos.</div>';
  document.getElementById('receiptModal').classList.add('open');
}
window.openReceipt=openReceipt;
function closeReceipt(){document.getElementById('receiptModal')?.classList.remove('open');receiptOrderId=null}
window.closeReceipt=closeReceipt;
function updateProductCostWeighted(p,qty,cost,beforeQty){
  if(!p||qty<=0)return;
  const method=settings().costMethod;
  const oldCost=n(p.cost);
  let newCost=cost;
  if(method==='weighted'){
    const baseQty=Math.max(0,beforeQty);
    newCost=(baseQty+qty)>0?((baseQty*oldCost)+(qty*cost))/(baseQty+qty):cost;
  }else if(method==='keep')return;
  const arr=products().map(x=>x.inventoryId===p.inventoryId?{...x,cost:String(newCost.toFixed(4))}:x);
  if(typeof setProducts==='function')setProducts(arr);
}
function saveReceipt(){
  try{
    const o=orderById(receiptOrderId);
    if(!o)return alert('Nepavyko rasti pirkimo užsakymo. Uždaryk priėmimą ir atidaryk jį dar kartą.');

    const linesEl=document.getElementById('receiptLines');
    const dateEl=document.getElementById('receiptDate');
    const refEl=document.getElementById('receiptReference');
    if(!linesEl)return alert('Priėmimo eilutės nepasiekiamos. Perkrauk puslapį ir bandyk dar kartą.');

    const rows=[...linesEl.querySelectorAll('.receive-line')];
    const chosen=rows.map(r=>({
      lineId:(r.dataset.lineId||'').trim(),
      lineIndex:Number(r.dataset.lineIndex),
      qty:Math.max(0,n(r.querySelector('.receive-qty')?.value))
    })).filter(x=>x.qty>0);

    if(!chosen.length)return alert('Nurodyk bent vienos prekės gaunamą kiekį.');

    const resolveLine=(x)=>{
      if(x.lineId){
        const byId=(o.lines||[]).find(z=>String(z.id||'')===x.lineId);
        if(byId)return byId;
      }
      if(Number.isInteger(x.lineIndex) && x.lineIndex>=0)return (o.lines||[])[x.lineIndex]||null;
      return null;
    };

    for(const x of chosen){
      const l=resolveLine(x);
      if(!l)return alert('Nepavyko susieti priėmimo eilutės su pirkimo užsakymu. Uždaryk langą ir atidaryk priėmimą dar kartą.');
      if(x.qty>remaining(l)+1e-9)return alert(`Per didelis gaunamas kiekis: ${l.name}`);
    }

    const receipt={
      id:id('rec'),
      date:dateEl?.value||today(),
      reference:(refEl?.value||'').trim(),
      createdAt:now(),
      lines:[]
    };

    for(const x of chosen){
      const l=resolveLine(x);
      if(!l)continue;

      /* Senesniems / automatiškai sukurtiems PO, kurių eilutė neturėjo ID, jį sukuriame dabar. */
      if(!l.id)l.id=id('pol');

      const p=product(l.productId);
      if(!p)return alert(`Prekė „${l.name||l.productId||'—'}“ neberasta kataloge. Patikrink prekės susiejimą.`);

      if(!window.MOGA_INVENTORY)return alert('Sandėlio modulis nepasiekiamas. Perkrauk puslapį ir bandyk dar kartą.');

      const inv=window.MOGA_INVENTORY.getRecord(p.inventoryId);
      if(!inv)return alert(`Nepavyko atidaryti prekės „${p.name||l.name||'—'}“ sandėlio kortelės.`);

      window.MOGA_INVENTORY?.ensureFifoInitialized?.();
      const before=n(inv.qty);
      const cost=effectiveLineCost(o,l);
      const after=before+x.qty;

      window.MOGA_INVENTORY.patchRecord(p.inventoryId,{qty:after});
      window.MOGA_INVENTORY.addMove({
        productId:p.inventoryId,
        type:'purchase',
        delta:x.qty,
        before,
        after,
        reference:o.no,
        note:`Priėmimas iš ${supplier(o.supplierId)?.name||'tiekėjo'}${receipt.reference?' · '+receipt.reference:''}`,
        unitCost:cost
      });

      const fifoLayer=window.MOGA_INVENTORY?.fifoAddPurchaseReceipt?.(p.inventoryId,x.qty,cost,{sourceRef:o.no,sourceLineId:l.id,receiptId:receipt.id,receivedAt:receipt.date||now(),note:`Priėmimas iš ${supplier(o.supplierId)?.name||'tiekėjo'}`});
      l.receivedQty=n(l.receivedQty)+x.qty;
      receipt.lines.push({lineId:l.id,productId:p.inventoryId,qty:x.qty,unitCost:cost,fifoLayerId:fifoLayer?.id||''});
    }

    if(!receipt.lines.length)return alert('Nebuvo priimta nė viena prekė.');

    o.receipts=o.receipts||[];
    o.receipts.push(receipt);
    o.status=orderStatusAuto(o);
    o.updatedAt=now();

    const arr=orders(),idx=arr.findIndex(x=>x.id===o.id);
    if(idx<0)return alert('Nepavyko išsaugoti pirkimo užsakymo pakeitimų.');
    arr[idx]=o;
    setOrders(arr);

    window.MOGA_INVENTORY.refresh?.();
    closeReceipt();
    renderAll();
    alert(`Priėmimas išsaugotas. Pirkimo užsakymo būsena: ${statusLabel(o.status)}.`);
  }catch(err){
    console.error('MOGA SF receipt save error:',err);
    alert(`Nepavyko priimti prekių į sandėlį: ${err?.message||err}`);
  }
}
window.saveReceipt=saveReceipt;

/* ---------------- Automatiniai papildymo pirkimo užsakymai ---------------- */
function createOrderFromSuggestionRow(x){
  if(!x.link)return null;
  return{id:id('pol'),productId:x.p.inventoryId,supplierLinkId:x.link.id,name:x.p.name,sku:x.p.sku||'',supplierSku:x.link.supplierSku||'',qty:Math.max(n(x.link.moq)||1,x.need),receivedQty:0,unitCost:n(x.link.unitCost),discount:0,notes:'Automatinis papildymo pasiūlymas'};
}
function createOrderFromOneSuggestion(pid){
  const x=reorderRows().find(x=>x.p.inventoryId===pid);if(!x?.link)return;
  const sp=supplier(x.link.supplierId),line=createOrderFromSuggestionRow(x);
  const o={id:id('po'),no:nextPoNo(),supplierId:sp.id,supplierSnapshot:{name:sp?.name||'',companyCode:sp?.companyCode||'',vatCode:sp?.vatCode||'',contactName:sp?.contactName||'',phone:sp?.phone||'',email:sp?.email||'',address:sp?.address||'',country:sp?.country||''},date:today(),expectedDate:'',status:'draft',reference:'Automatinis papildymas',tracking:'',currency:sp.currency||settings().currency,shipping:0,otherCosts:0,discount:0,vatRate:settings().defaultVatRate,pricesIncludeVat:false,paidAmount:0,notes:'Sukurta iš „Reikia užsakyti“',lines:[line],receipts:[],createdAt:now(),updatedAt:now()};
  setOrders([...orders(),o]);switchPane('orders');renderOrders();
}
window.createOrderFromOneSuggestion=createOrderFromOneSuggestion;
function createOrdersFromSuggestions(){
  const rows=reorderRows().filter(x=>x.link);
  if(!rows.length)return alert('Nėra susietų papildymo pasiūlymų.');
  const groups=new Map();rows.forEach(x=>{const sid=x.link.supplierId;if(!groups.has(sid))groups.set(sid,[]);groups.get(sid).push(x)});
  const arr=orders();
  groups.forEach((rr,sid)=>{
    const sp=supplier(sid);
    arr.push({id:id('po'),no:nextPoNo(),supplierId:sid,supplierSnapshot:{name:sp?.name||'',companyCode:sp?.companyCode||'',vatCode:sp?.vatCode||'',contactName:sp?.contactName||'',phone:sp?.phone||'',email:sp?.email||'',address:sp?.address||'',country:sp?.country||''},date:today(),expectedDate:'',status:'draft',reference:'Automatinis papildymas',tracking:'',currency:sp?.currency||settings().currency,shipping:0,otherCosts:0,discount:0,vatRate:settings().defaultVatRate,pricesIncludeVat:false,paidAmount:0,notes:'Sukurta iš „Reikia užsakyti“',lines:rr.map(createOrderFromSuggestionRow),receipts:[],createdAt:now(),updatedAt:now()});
  });
  setOrders(arr);switchPane('orders');renderOrders();alert(`Sukurta pirkimo užsakymų: ${groups.size}.`);
}
window.createOrdersFromSuggestions=createOrdersFromSuggestions;

/* ---------------- Nustatymai ir eksportas ---------------- */
function loadPurchaseSettings(){
  const x=settings();
  if(document.getElementById('purchaseCostMethod'))purchaseCostMethod.value='fifo';
  if(document.getElementById('purchaseTargetMultiplier'))purchaseTargetMultiplier.value=x.targetMultiplier;
  if(document.getElementById('purchaseDefaultVat'))purchaseDefaultVat.value=x.defaultVatRate;
}
function savePurchaseSettings(){
  setSettings({costMethod:'fifo',targetMultiplier:Math.max(1,n(purchaseTargetMultiplier.value)||2),defaultVatRate:Math.max(0,n(purchaseDefaultVat.value))});
  renderReorder();
}
window.savePurchaseSettings=savePurchaseSettings;
function exportPurchasesCsv(){
  const rows=orders(),csv=[['PO','Data','Tiekėjas','Būsena','Suma','Apmokėta','Skola','Užsakyta vnt.','Gauta vnt.','Laukiama vnt.','Numatoma data','Sekimas'],
  ...rows.map(o=>{const c=orderCalc(o),q=(o.lines||[]).reduce((a,l)=>a+n(l.qty),0),g=(o.lines||[]).reduce((a,l)=>a+n(l.receivedQty),0);return[o.no,o.date,supplierNameForOrder(o),statusLabel(o.status),c.total,c.paid,c.outstanding,q,g,q-g,o.expectedDate||'',o.tracking||'']})]
  .map(r=>r.map(v=>`"${String(v??'').replace(/"/g,'""')}"`).join(';')).join('\n');
  const blob=new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=`SF_Pirkimai_${today()}.csv`;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
window.exportPurchasesCsv=exportPurchasesCsv;

function purchaseSheetIsActive(){return !!document.getElementById('purchaseSheet')?.classList.contains('active')}
function renderAll(){
  if(!premium())return;
  /* Nebeskaičiuojame 5 paslėptų skilties lentelių vienu metu.
     Tai ypač brangu dėl ~600 katalogo prekių ir tiekėjų susiejimų. */
  renderActivePurchasePane();
  loadPurchaseSettings();
}
window.renderPurchasesAll=renderAll;

const renderPurchasesIfVisible=()=>{if(purchaseSheetIsActive())setTimeout(renderAll,0)};
window.addEventListener('moga:plan-change',renderPurchasesIfVisible);
window.addEventListener('moga:data-ready',renderPurchasesIfVisible);
/* Startuojant programai PIRKIMŲ paslėptų lentelių iš anksto neberenderiname.
   Pirmą atidarymą atlieka setPage('purchases'), todėl kitos programos skiltys nebestabdomos. */

window.MOGA_PURCHASES={suppliers,setSuppliers,links,orders,setOrders,settings,orderCalc,supplierNameForOrder,incomingForProduct,reorderRows,render:renderAll};

(function installSharedDocumentStyle(){
  const id='moga-shared-document-style-v2';
  if(document.getElementById(id))return;
  const style=document.createElement('style'); style.id=id;
  style.textContent=`
    .moga-shared-doc{
      width:100%!important;max-width:none!important;min-width:0!important;box-sizing:border-box;margin:18px 0 20px;border:1px solid #eadfce;
      grid-column:1 / -1!important;flex:1 0 100%!important;align-self:stretch!important;
      border-radius:16px;background:#fffaf4;overflow:hidden;transition:.25s ease;
    }
    .moga-shared-doc-toggle{
      width:100%;box-sizing:border-box;display:flex!important;align-items:center;gap:12px;
      padding:13px 16px!important;margin:0!important;cursor:pointer;user-select:none;
    }
    .moga-shared-doc-toggle>span:last-child{display:flex;flex-direction:column;gap:2px;min-width:0}
    .moga-shared-doc-toggle b{font-size:13px;line-height:1.25;color:#171717}
    .moga-shared-doc-toggle small{font-size:11px;line-height:1.3;color:#777;font-weight:500}
    .moga-shared-doc-check{position:relative;width:28px;height:28px;flex:0 0 28px}
    .moga-shared-doc-check input{position:absolute;inset:0;width:28px!important;height:28px!important;opacity:0;cursor:pointer}
    .moga-shared-doc-check span{
      position:absolute;inset:0;border:1px solid #c9c1b7;border-radius:9px;background:#fff;
      display:grid;place-items:center;font-size:0;transition:.2s ease;pointer-events:none
    }
    .moga-shared-doc-check input:checked+span{
      border-color:transparent;background:linear-gradient(135deg,#ff8a00,#ff3f8e);font-size:15px;color:#fff
    }
    .moga-shared-doc-fields{
      max-height:0;opacity:0;overflow:hidden;padding:0 16px;transform:translateY(-5px);
      transition:max-height .32s ease,opacity .22s ease,transform .28s ease,padding .28s ease;
      border-top:0 solid #eadfce
    }
    .moga-shared-doc-fields.open{
      max-height:260px;opacity:1;transform:translateY(0);padding:14px 16px 16px;border-top-width:1px
    }
    .moga-shared-doc-grid{
      display:grid!important;grid-template-columns:minmax(220px,1.5fr) minmax(150px,.75fr) minmax(180px,.9fr);
      gap:12px;width:100%
    }
    .moga-shared-doc-grid label{display:flex!important;flex-direction:column;gap:6px;margin:0!important;min-width:0}
    .moga-shared-doc-grid label>span{font-size:11px;font-weight:800;color:#555}
    .moga-shared-doc-grid input{
      width:100%!important;min-width:0!important;box-sizing:border-box!important;height:40px!important;
      padding:0 11px!important;border:1px solid #cfcfcf!important;border-radius:10px!important;background:#fff!important;
      color:#111!important;font-size:13px!important
    }
    .moga-shared-doc-summary{
      margin-top:12px;padding:10px 12px;border-radius:10px;background:#fff;font-size:12px!important;
      font-weight:800!important;line-height:1.45;white-space:normal
    }
    @media(max-width:760px){
      .moga-shared-doc-grid{grid-template-columns:1fr}
      .moga-shared-doc-fields.open{max-height:430px}
    }
  `;
  document.head.appendChild(style);
})();


(function installMogaDialogTopLayerFix(){
  const id='moga-dialog-top-layer-fix-v1';
  if(document.getElementById(id))return;
  const st=document.createElement('style'); st.id=id;
  st.textContent=`
    .moga-global-dialog-overlay,
    .moga-dialog-overlay,
    .moga-ui-dialog-overlay,
    [class*="moga"][class*="dialog"][class*="overlay"]{
      z-index:2147483646!important;
    }
    .moga-global-dialog,
    .moga-dialog,
    .moga-ui-dialog,
    [class*="moga"][class*="dialog"]:not([class*="overlay"]){
      z-index:2147483647!important;
    }
  `;
  document.head.appendChild(st);

  /* Jei dialogas buvo sukurtas modal'o viduje, perkeliame jį tiesiai į BODY.
     Taip jis nebegali atsidurti po purchase/expense modal'o stacking context. */
  const lift=()=>{
    document.querySelectorAll(
      '.moga-global-dialog-overlay,.moga-dialog-overlay,.moga-ui-dialog-overlay'
    ).forEach(el=>{
      if(el.parentElement!==document.body) document.body.appendChild(el);
      el.style.setProperty('z-index','2147483646','important');
    });
    document.querySelectorAll(
      '.moga-global-dialog,.moga-dialog,.moga-ui-dialog'
    ).forEach(el=>{
      el.style.setProperty('z-index','2147483647','important');
    });
  };
  lift();
  new MutationObserver(lift).observe(document.body,{childList:true,subtree:true});
})();


(function installPoLineGroupStyle(){
  const id='moga-po-line-group-style-v1';if(document.getElementById(id))return;
  const st=document.createElement('style');st.id=id;st.textContent=`
    #poLineBody .po-line-group-select{width:100%;min-width:145px;max-width:210px;height:36px;border:1px solid #ccc;border-radius:8px;background:#fff;padding:0 30px 0 9px;font-size:11px;font-weight:700;color:#222}
    #poLineBody td:has(.po-line-group-select){min-width:155px}
  `;document.head.appendChild(st);
})();

})();

(function installSupplierLinkCheckboxStyle(){
  const id='moga-supplier-link-checkbox-style-v2';if(document.getElementById(id))return;
  const st=document.createElement('style');st.id=id;st.textContent=`
    #supplierLinkProducts input[type="checkbox"],
    #supplierLinkBody .supplier-link-row-check,
    #supplierLinkSelectVisible{
      -webkit-appearance:none!important;appearance:none!important;
      width:20px!important;height:20px!important;min-width:20px!important;
      margin:0!important;border:1.5px solid #c8c8c8!important;border-radius:6px!important;
      background:#fff!important;display:inline-grid!important;place-content:center!important;
      cursor:pointer!important;vertical-align:middle!important;transition:.15s ease!important;
    }
    #supplierLinkProducts input[type="checkbox"]:hover,
    #supplierLinkBody .supplier-link-row-check:hover,
    #supplierLinkSelectVisible:hover{
      border-color:#ff7a19!important;box-shadow:0 0 0 3px rgba(255,122,25,.10)!important;
    }
    #supplierLinkProducts input[type="checkbox"]:checked,
    #supplierLinkBody .supplier-link-row-check:checked,
    #supplierLinkSelectVisible:checked,
    #supplierLinkSelectVisible:indeterminate{
      border-color:transparent!important;background:linear-gradient(135deg,#ff8a00,#ff4b93)!important;
    }
    #supplierLinkProducts input[type="checkbox"]:checked::after,
    #supplierLinkBody .supplier-link-row-check:checked::after,
    #supplierLinkSelectVisible:checked::after{
      content:'✓';color:#fff;font-size:14px;font-weight:1000;line-height:1;
    }
    #supplierLinkSelectVisible:indeterminate::after{content:'−';color:#fff;font-size:15px;font-weight:1000;line-height:1}
    .supplier-link-select-col{width:42px!important;min-width:42px!important;text-align:center!important}

    .supplier-link-bulk-bar{
      display:none;justify-content:flex-end;align-items:center;
      margin:10px 0 10px;padding:0;background:transparent;
    }
    .supplier-link-bulk-delete{
      width:auto!important;min-width:0!important;height:38px!important;min-height:38px!important;
      padding:0 14px!important;margin:0!important;
      border:1px solid #d8a0a0!important;border-radius:10px!important;
      background:#fff!important;color:#a40000!important;
      font-size:12px!important;font-weight:900!important;line-height:1!important;
      box-shadow:none!important;cursor:pointer!important;white-space:nowrap!important;
    }
    .supplier-link-bulk-delete:hover{
      background:#fff1f1!important;border-color:#c40000!important;color:#8f0000!important;
    }
    #purchaseSheet .supplier-link-sort-wrap{
      position:relative;min-width:175px;max-width:190px;flex:0 0 auto;
    }
    #purchaseSheet .supplier-link-sort-button{
      width:100%;height:40px;display:grid;grid-template-columns:1fr 24px 14px;gap:6px;align-items:center;
      padding:0 10px 0 12px;border:1px solid #d5d5d5;border-radius:10px;background:#fff;color:#111;
      font-size:12px;font-weight:900;cursor:pointer;text-align:left;
    }
    #purchaseSheet .supplier-link-sort-button:hover,
    #purchaseSheet .supplier-link-sort-button[aria-expanded="true"]{
      border-color:#e2a632;box-shadow:0 0 0 2px rgba(226,166,50,.18);
    }
    #purchaseSheet .supplier-link-sort-badge{
      width:22px;height:22px;border-radius:7px;display:grid;place-items:center;
      background:#171717;color:#fff;font-size:11px;font-weight:1000;
    }
    #purchaseSheet .supplier-link-sort-caret{font-size:8px;text-align:center}
    #purchaseSheet .supplier-link-sort-menu{
      position:absolute;right:0;top:calc(100% + 6px);display:none;width:250px;padding:6px;
      background:#1d1d22;border:1px solid #3a3a42;border-radius:12px;box-shadow:0 16px 38px rgba(0,0,0,.30);z-index:1000;
    }
    #purchaseSheet .supplier-link-sort-menu.open{display:block}
    #purchaseSheet .supplier-link-sort-row{
      display:grid;grid-template-columns:1fr auto;align-items:center;gap:10px;padding:7px 8px;border-radius:8px;color:#fff;
    }
    #purchaseSheet .supplier-link-sort-row:hover{background:#2a2a31}
    #purchaseSheet .supplier-link-sort-row>span{font-size:12px;font-weight:800}
    #purchaseSheet .supplier-link-sort-row>div{display:flex;gap:5px}
    #purchaseSheet .supplier-link-sort-row button{
      width:30px;height:28px;padding:0;border:1px solid #4a4a54;border-radius:8px;background:#303038;color:#fff;
      font-size:12px;font-weight:1000;cursor:pointer;
    }
    #purchaseSheet .supplier-link-sort-row button:hover{background:#44444e}
    #purchaseSheet .supplier-link-sort-row button.active{
      border-color:transparent;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;
    }

  `;document.head.appendChild(st);
})();
